/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type ActiveUniqueProfileMetricsResponse = {
  __typename?: 'ActiveUniqueProfileMetricsResponse';
  totalProfiles: Scalars['Float']['output'];
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  provinceCode?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Method used for data aggregation */
export enum AggregateMethod {
  AggregateMethodAvg = 'AGGREGATE_METHOD_AVG',
  AggregateMethodMax = 'AGGREGATE_METHOD_MAX',
  AggregateMethodMedian = 'AGGREGATE_METHOD_MEDIAN',
  AggregateMethodMin = 'AGGREGATE_METHOD_MIN',
  AggregateMethodSum = 'AGGREGATE_METHOD_SUM',
  AggregateMethodUnique = 'AGGREGATE_METHOD_UNIQUE',
  AggregateMethodUnspecified = 'AGGREGATE_METHOD_UNSPECIFIED'
}

export type AttentiveCredentials = {
  __typename?: 'AttentiveCredentials';
  attentiveApiKey: Scalars['String']['output'];
};

export type AttentiveCredentialsModel = {
  __typename?: 'AttentiveCredentialsModel';
  attentiveApiKey: Scalars['String']['output'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  generatedAt?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  metrics: CampaignMetrics;
  name: Scalars['String']['output'];
  scheduled?: Maybe<Scalars['JSON']['output']>;
  segments: Segments;
  status: CampaignStatus;
  type: CampaignType;
  updatedAt: Scalars['String']['output'];
  variants: Array<CampaignVariant>;
};

export type CampaignMetrics = {
  __typename?: 'CampaignMetrics';
  clicked: Scalars['Float']['output'];
  earned: Scalars['Float']['output'];
  opened: Scalars['Float']['output'];
  ordered: Scalars['Float']['output'];
  sent: Scalars['Float']['output'];
};

/** Status of a campaign */
export enum CampaignStatus {
  Delivered = 'DELIVERED',
  Draft = 'DRAFT',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Suspended = 'SUSPENDED',
  Unspecified = 'UNSPECIFIED'
}

/** Type of campaign */
export enum CampaignType {
  Blast = 'BLAST',
  SplitSend = 'SPLIT_SEND',
  Unspecified = 'UNSPECIFIED'
}

export type CampaignVariant = {
  __typename?: 'CampaignVariant';
  campaignId: Scalars['String']['output'];
  channel: Channel;
  content?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  splitWeight: Scalars['Float']['output'];
  updatedAt: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
};

export type CampaignVariantInput = {
  channel: Channel;
  content?: InputMaybe<Scalars['JSON']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  splitWeight: Scalars['Float']['input'];
  variantName: Scalars['String']['input'];
};

export enum CanonicalEventName {
  CartsUpdate = 'CARTS_UPDATE',
  CartViewed = 'CART_VIEWED',
  CheckoutsCreate = 'CHECKOUTS_CREATE',
  CheckoutAddressInfoSubmitted = 'CHECKOUT_ADDRESS_INFO_SUBMITTED',
  CheckoutCompleted = 'CHECKOUT_COMPLETED',
  CheckoutContactInfoSubmitted = 'CHECKOUT_CONTACT_INFO_SUBMITTED',
  CheckoutShippingInfoSubmitted = 'CHECKOUT_SHIPPING_INFO_SUBMITTED',
  CheckoutStarted = 'CHECKOUT_STARTED',
  CollectionViewed = 'COLLECTION_VIEWED',
  ContactInfoCaptured = 'CONTACT_INFO_CAPTURED',
  CustomersEmailMarketingConsentUpdate = 'CUSTOMERS_EMAIL_MARKETING_CONSENT_UPDATE',
  CustomersMarketingConsentUpdate = 'CUSTOMERS_MARKETING_CONSENT_UPDATE',
  NewsletterSubscribed = 'NEWSLETTER_SUBSCRIBED',
  NewCustomerPurchase = 'NEW_CUSTOMER_PURCHASE',
  OrdersCreate = 'ORDERS_CREATE',
  PageViewed = 'PAGE_VIEWED',
  PaymentInfoSubmitted = 'PAYMENT_INFO_SUBMITTED',
  ProductAddedToCart = 'PRODUCT_ADDED_TO_CART',
  ProductRemovedFromCart = 'PRODUCT_REMOVED_FROM_CART',
  ProductViewed = 'PRODUCT_VIEWED',
  RefundsCreate = 'REFUNDS_CREATE',
  ReturningCustomerPurchase = 'RETURNING_CUSTOMER_PURCHASE',
  SearchSubmitted = 'SEARCH_SUBMITTED',
  SubscriptionPurchase = 'SUBSCRIPTION_PURCHASE',
  Unspecified = 'UNSPECIFIED',
  UserScrolled = 'USER_SCROLLED'
}

/** The channel type for campaign variants */
export enum Channel {
  Email = 'EMAIL',
  Push = 'PUSH',
  Sms = 'SMS'
}

/** Unit of time for chart data */
export enum ChartUnit {
  ChartUnitDay = 'CHART_UNIT_DAY',
  ChartUnitMonth = 'CHART_UNIT_MONTH',
  ChartUnitUnspecified = 'CHART_UNIT_UNSPECIFIED',
  ChartUnitWeek = 'CHART_UNIT_WEEK'
}

export type ClaimAdminListQueryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ClaimStatus>>;
};

export type ClaimAuthResponse = {
  __typename?: 'ClaimAuthResponse';
  errorReason?: Maybe<ClaimErrorReason>;
  token: Scalars['String']['output'];
};

export type ClaimEligibilityModel = {
  __typename?: 'ClaimEligibilityModel';
  claimRejectionCode?: Maybe<IneligibilityCode>;
  claimRejectionMessage?: Maybe<Scalars['String']['output']>;
  isClaimable: Scalars['Boolean']['output'];
};

export enum ClaimErrorReason {
  FriendlyWasRefunded = 'FRIENDLY_WAS_REFUNDED',
  OrderAlreadyClaimed = 'ORDER_ALREADY_CLAIMED',
  OrderCancelled = 'ORDER_CANCELLED',
  OrderHasNoFulfillments = 'ORDER_HAS_NO_FULFILLMENTS',
  OrderNotClaimable = 'ORDER_NOT_CLAIMABLE',
  OrderNotFound = 'ORDER_NOT_FOUND'
}

export type ClaimExchangeItemModel = {
  __typename?: 'ClaimExchangeItemModel';
  claimExchangeItemCreatedAt: Scalars['String']['output'];
  claimExchangeItemUpdatedAt: Scalars['String']['output'];
  claimItemId: Scalars['String']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  externalProductId: Scalars['String']['output'];
  externalVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variantTitle: Scalars['String']['output'];
};

export type ClaimExchangeModel = {
  __typename?: 'ClaimExchangeModel';
  adjustmentId: Scalars['String']['output'];
  claimExchangeCreatedAt: Scalars['String']['output'];
  claimExchangeId: Scalars['String']['output'];
  claimExchangeUpdatedAt: Scalars['String']['output'];
  exchangeItems: Array<ClaimExchangeItemModel>;
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  shopCurrency: Scalars['String']['output'];
  status: ExchangeStatus;
};

export type ClaimItemModel = {
  __typename?: 'ClaimItemModel';
  claimItemCreatedAt: Scalars['String']['output'];
  claimItemCustomerNotes?: Maybe<Scalars['String']['output']>;
  claimItemId: Scalars['String']['output'];
  claimItemOriginalPackagingPhotoUrl?: Maybe<Scalars['String']['output']>;
  claimItemProductPhotoUrl?: Maybe<Scalars['String']['output']>;
  claimItemStatus: ClaimItemStatus;
  claimItemUpdatedAt: Scalars['String']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalVariantId?: Maybe<Scalars['String']['output']>;
  outcome: ClaimItemOutcome;
  quantity: Scalars['Int']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  variantTitle?: Maybe<Scalars['String']['output']>;
};

export enum ClaimItemOutcome {
  Exchange = 'EXCHANGE',
  Refund = 'REFUND'
}

export enum ClaimItemStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED'
}

export type ClaimMerchantListQueryInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<ClaimStatus>>;
};

export type ClaimModel = {
  __typename?: 'ClaimModel';
  claimCreatedAt: Scalars['String']['output'];
  claimId: Scalars['String']['output'];
  claimItems: Array<ClaimItemModel>;
  claimReason: ClaimType;
  claimStatus: ClaimStatus;
  claimUpdatedAt: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  exchanges: Array<ClaimExchangeModel>;
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantUrl?: Maybe<Scalars['String']['output']>;
  order?: Maybe<OrderSummaryModel>;
  orderName: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policeReportUrl?: Maybe<Scalars['String']['output']>;
  refunds: Array<ClaimRefundModel>;
  shippingAddress?: Maybe<Address>;
  shopCurrency: Scalars['String']['output'];
  trackingCompany?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type ClaimRefundItemModel = {
  __typename?: 'ClaimRefundItemModel';
  claimItemId: Scalars['String']['output'];
  claimRefundItemCreatedAt: Scalars['String']['output'];
  claimRefundItemUpdatedAt: Scalars['String']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  externalProductId: Scalars['String']['output'];
  externalVariantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
  title: Scalars['String']['output'];
  variantTitle: Scalars['String']['output'];
};

export type ClaimRefundModel = {
  __typename?: 'ClaimRefundModel';
  adjustmentId: Scalars['String']['output'];
  claimRefundCreatedAt: Scalars['String']['output'];
  claimRefundId: Scalars['String']['output'];
  claimRefundUpdatedAt: Scalars['String']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  refundItems: Array<ClaimRefundItemModel>;
  shopCurrency: Scalars['String']['output'];
  status: RefundStatus;
};

export enum ClaimStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED',
  Draft = 'DRAFT',
  MoreInformationRequested = 'MORE_INFORMATION_REQUESTED',
  PartiallyProcessed = 'PARTIALLY_PROCESSED',
  Pending = 'PENDING',
  Processed = 'PROCESSED'
}

export enum ClaimType {
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  Stolen = 'STOLEN'
}

export enum ComparisonOperator {
  Contains = 'CONTAINS',
  DoesNotContain = 'DOES_NOT_CONTAIN',
  Equal = 'EQUAL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  Is = 'IS',
  IsNot = 'IS_NOT',
  IsNotSet = 'IS_NOT_SET',
  IsSet = 'IS_SET',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  NotEqual = 'NOT_EQUAL'
}

export type ConditionGroup = {
  __typename?: 'ConditionGroup';
  conditions: Array<ConditionInterface>;
  id?: Maybe<Scalars['ID']['output']>;
  operator: SegmentOperator;
};

export type ConditionGroupInput = {
  /** Array of Condition Input objects (Event, UserProperty, Funnel, etc.) */
  conditions: Array<Scalars['JSONObject']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  operator: SegmentOperator;
};

export type ConditionInterface = {
  conditionType: ConditionTypeEnum;
  id?: Maybe<Scalars['ID']['output']>;
};

/** The specific type of a condition criterion */
export enum ConditionTypeEnum {
  Event = 'EVENT',
  Funnel = 'FUNNEL',
  SegmentMembership = 'SEGMENT_MEMBERSHIP',
  UserProperty = 'USER_PROPERTY'
}

export enum ConnectionStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR'
}

export enum ConnectionStatusV2 {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Error = 'ERROR'
}

export type ContactPreferencesDto = {
  __typename?: 'ContactPreferencesDto';
  ianaTimezone: Scalars['String']['output'];
  languagePreference: Scalars['String']['output'];
  optInEmail: Scalars['Boolean']['output'];
  optInSms: Scalars['Boolean']['output'];
};

export enum ContentType {
  OrderId = 'ORDER_ID',
  OrderName = 'ORDER_NAME',
  OrderNumber = 'ORDER_NUMBER',
  Product = 'PRODUCT',
  ProductGroup = 'PRODUCT_GROUP',
  Unspecified = 'UNSPECIFIED'
}

export enum ConversionUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Minute = 'MINUTE',
  Week = 'WEEK'
}

export type ConversionWindow = {
  __typename?: 'ConversionWindow';
  conversion_unit: ConversionUnit;
  num_unit: Scalars['Int']['output'];
};

export enum CountOperator {
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualTo = 'GREATER_THAN_OR_EQUAL_TO',
  LessThan = 'LESS_THAN',
  LessThanOrEqualTo = 'LESS_THAN_OR_EQUAL_TO',
  NotEqualTo = 'NOT_EQUAL_TO'
}

export type CreateCampaignInput = {
  createdBy: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  segments: SegmentsInput;
  variants: Array<CampaignVariantInput>;
};

export type CreateIntegrationInput = {
  name: Scalars['String']['input'];
  type: IntegrationType;
};

export type CreateIntegrationInputV2 = {
  name: Scalars['String']['input'];
  type: IntegrationTypeV2;
};

export type CreatePortalClaim = {
  claimItems: Array<CreatePortalClaimItem>;
  claimReason: ClaimType;
  externalFulfillmentId: Scalars['String']['input'];
  policeReportUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePortalClaimItem = {
  claimItemCustomerNotes?: InputMaybe<Scalars['String']['input']>;
  claimItemOriginalPackagingPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  claimItemProductPhotoUrl?: InputMaybe<Scalars['String']['input']>;
  externalOrderItemId: Scalars['String']['input'];
  outcome: ClaimItemOutcome;
  quantity: Scalars['Int']['input'];
};

export type CreateSegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groups: Array<ConditionGroupInput>;
  name: Scalars['String']['input'];
  rootOperator: SegmentOperator;
};

export type CreateSignedUrlInput = {
  contentType: Scalars['String']['input'];
  documentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type CreateSignedUrlResponse = {
  __typename?: 'CreateSignedURLResponse';
  path: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type Ctid = {
  __typename?: 'Ctid';
  id: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
  userCreated: Scalars['Boolean']['output'];
};

export type CtidEntry = {
  __typename?: 'CtidEntry';
  ctid: Ctid;
  event: Scalars['String']['output'];
};

export type CtidEntryInput = {
  ctid: CtidInput;
  event: Scalars['String']['input'];
};

export type CtidInput = {
  id: Scalars['String']['input'];
  selected?: Scalars['Boolean']['input'];
  userCreated?: Scalars['Boolean']['input'];
};

export type CustomAppCredsModel = {
  __typename?: 'CustomAppCredsModel';
  appHandle: Scalars['String']['output'];
  appName: Scalars['String']['output'];
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/** Type of DNS record */
export enum DnsRecordType {
  Cname = 'CNAME',
  Txt = 'TXT'
}

export type DailyEmqScore = {
  __typename?: 'DailyEMQScore';
  META_ADD_PAYMENT_INFO_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_ADD_TO_CART_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_INITIATE_CHECKOUT_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_LEAD_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_PAGE_VIEW_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_PURCHASE_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  META_VIEW_CONTENT_EMQ_SCORE?: Maybe<Scalars['Float']['output']>;
  date: Scalars['String']['output'];
};

export type DateRange = {
  __typename?: 'DateRange';
  fromDate: Scalars['String']['output'];
  toDate: Scalars['String']['output'];
};

export type DefaultAndAverageRow = {
  __typename?: 'DefaultAndAverageRow';
  currentAvg?: Maybe<Scalars['Float']['output']>;
  eventName: Scalars['String']['output'];
  priorScore?: Maybe<Scalars['Float']['output']>;
};

/** DNS record */
export type DnsRecord = {
  __typename?: 'DnsRecord';
  /** Hostname */
  hostname: Scalars['String']['output'];
  /** ID */
  id: Scalars['ID']['output'];
  /** Name */
  name: Scalars['String']['output'];
  /** Type */
  type: DnsRecordType;
  /** Value */
  value: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type EmqBaselineScoreResult = {
  __typename?: 'EMQBaselineScoreResult';
  baselineScore?: Maybe<EmqDailyScore>;
};

export type EmqDailyScore = {
  __typename?: 'EMQDailyScore';
  date: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
  missingEvents: Array<Scalars['String']['output']>;
  scores: Array<EmqScore>;
  source: EmqScoreSource;
  type: EmqScoreType;
};

export type EmqQueryResult = {
  __typename?: 'EMQQueryResult';
  scores: Array<EmqDailyScore>;
};

export type EmqScore = {
  __typename?: 'EMQScore';
  eventName: Scalars['String']['output'];
  score: Scalars['Float']['output'];
};

export type EmqScoreAverageAndTrend = {
  __typename?: 'EMQScoreAverageAndTrend';
  avgScore?: Maybe<Scalars['Float']['output']>;
  endScore?: Maybe<Scalars['Float']['output']>;
  priorScore?: Maybe<Scalars['Float']['output']>;
};

export type EmqScoreEventInput = {
  eventName: Scalars['String']['input'];
  score: Scalars['Float']['input'];
};

export type EmqScoreInput = {
  date: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  scores: Array<EmqScoreEventInput>;
  source: EmqScoreSource;
};

export type EmqScoreResult = {
  __typename?: 'EMQScoreResult';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Source of EMQ score */
export enum EmqScoreSource {
  Meta = 'META'
}

/** Type of EMQ score */
export enum EmqScoreType {
  Baseline = 'BASELINE',
  DailyUpdate = 'DAILY_UPDATE'
}

export type EligibleClaimTypeModel = {
  __typename?: 'EligibleClaimTypeModel';
  canClaim: Scalars['Boolean']['output'];
  type: ClaimType;
};

export type EmailCaptureRateResponse = {
  __typename?: 'EmailCaptureRateResponse';
  emailCaptureRate: Scalars['Float']['output'];
};

export enum EmailSource {
  Contextual = 'CONTEXTUAL',
  Voldemort = 'VOLDEMORT'
}

export type EstimateSegmentDefinitionInput = {
  merchantId: Scalars['ID']['input'];
  segmentDefinition: SegmentDefinitionInput;
};

export type EventCondition = ConditionInterface & {
  __typename?: 'EventCondition';
  conditionType: ConditionTypeEnum;
  eventName: CanonicalEventName;
  id?: Maybe<Scalars['ID']['output']>;
  numTimes: Scalars['Int']['output'];
  operator: CountOperator;
  timeBoundary: TimeBoundary;
};

export enum ExchangeStatus {
  Created = 'CREATED',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Removed = 'REMOVED'
}

export type Filter = {
  __typename?: 'Filter';
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  propertyFilters: Array<PropertyFilter>;
};

export type FilterV2 = {
  __typename?: 'FilterV2';
  eventName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  propertyFilters: Array<PropertyFilterV2>;
};

export type FindClaimByIdResult = {
  __typename?: 'FindClaimByIdResult';
  claim?: Maybe<ClaimModel>;
};

export type FindClaims = {
  __typename?: 'FindClaims';
  claims: Array<ClaimModel>;
  metadata: ListMetadata;
};

export type FindSegmentQueryResult = {
  __typename?: 'FindSegmentQueryResult';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastCalculatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastCalculatedSize?: Maybe<Scalars['Float']['output']>;
  lastUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  lastUpdatedBy: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentSegmentIds: Array<Scalars['String']['output']>;
  segment: SegmentDefinition;
};

export type FriendlyBrand = {
  __typename?: 'FriendlyBrand';
  brandSettings?: Maybe<FriendlyBrandSettings>;
  product?: Maybe<FriendlyProduct>;
  subDomains: Array<Scalars['String']['output']>;
};

export type FriendlyBrandImage = {
  __typename?: 'FriendlyBrandImage';
  gcsPath: Scalars['String']['output'];
  publicImageUrl: Scalars['String']['output'];
};

export type FriendlyBrandSettings = {
  __typename?: 'FriendlyBrandSettings';
  buttonColor?: Maybe<Scalars['String']['output']>;
  buttonTextColor?: Maybe<Scalars['String']['output']>;
  claimPortalUrl?: Maybe<FriendlyBrandImage>;
  shopifyLogo?: Maybe<FriendlyBrandImage>;
};

export type FriendlyBrandSettingsInput = {
  buttonColor?: InputMaybe<Scalars['String']['input']>;
  buttonTextColor?: InputMaybe<Scalars['String']['input']>;
  claimPortalGcsPath?: InputMaybe<Scalars['String']['input']>;
  logoGcsPath?: InputMaybe<Scalars['String']['input']>;
};

export type FriendlyBrandSettingsResult = {
  __typename?: 'FriendlyBrandSettingsResult';
  success: Scalars['Boolean']['output'];
};

export type FriendlyProduct = {
  __typename?: 'FriendlyProduct';
  id: Scalars['String']['output'];
  variants: Array<FriendlyProductVariant>;
};

export type FriendlyProductUpdateResult = {
  __typename?: 'FriendlyProductUpdateResult';
  success: Scalars['Boolean']['output'];
};

export type FriendlyProductVariant = {
  __typename?: 'FriendlyProductVariant';
  id: Scalars['String']['output'];
  price: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type FulfillmentClaimModel = {
  __typename?: 'FulfillmentClaimModel';
  claimEligibility: ClaimEligibilityModel;
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  eligibleClaimTypes: Array<EligibleClaimTypeModel>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  fulfillmentCreatedAt: Scalars['DateTime']['output'];
  fulfillmentItems: Array<FulfillmentItemClaimModel>;
  fulfillmentUpdatedAt: Scalars['DateTime']['output'];
  lastTrackingUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  merchantId: Scalars['String']['output'];
  shipmentStatus?: Maybe<Scalars['String']['output']>;
  trackingCompany?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type FulfillmentItemClaimModel = {
  __typename?: 'FulfillmentItemClaimModel';
  claimedQuantity: Scalars['Int']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  maxClaimableQuantity: Scalars['Int']['output'];
  merchantId: Scalars['String']['output'];
  orderItem?: Maybe<OrderItemModel>;
  quantity: Scalars['Int']['output'];
};

export type FulfillmentItemModel = {
  __typename?: 'FulfillmentItemModel';
  claimedQuantity: Scalars['Int']['output'];
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  merchantId: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
};

export type FulfillmentModel = {
  __typename?: 'FulfillmentModel';
  deliveredDate?: Maybe<Scalars['DateTime']['output']>;
  expectedDeliveryDate?: Maybe<Scalars['DateTime']['output']>;
  externalFulfillmentId: Scalars['String']['output'];
  externalOrderId: Scalars['String']['output'];
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  fulfillmentCreatedAt: Scalars['DateTime']['output'];
  fulfillmentItems: Array<FulfillmentItemModel>;
  fulfillmentUpdatedAt: Scalars['DateTime']['output'];
  lastTrackingUpdateDate?: Maybe<Scalars['DateTime']['output']>;
  merchantId: Scalars['String']['output'];
  shipmentStatus?: Maybe<Scalars['String']['output']>;
  trackingCompany?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type FunnelCondition = ConditionInterface & {
  __typename?: 'FunnelCondition';
  conditionType: ConditionTypeEnum;
  id?: Maybe<Scalars['ID']['output']>;
  maxSecondsBetweenSteps: Scalars['Int']['output'];
  steps: Array<FunnelStep>;
  timeBoundary: TimeBoundary;
};

export type FunnelStep = {
  __typename?: 'FunnelStep';
  countOperator: CountOperator;
  eventName: CanonicalEventName;
  numTimes: Scalars['Int']['output'];
  stepId?: Maybe<Scalars['ID']['output']>;
};

export type Ga4Credentials = {
  __typename?: 'GA4Credentials';
  measurementId: Scalars['String']['output'];
};

export type Ga4CredentialsModel = {
  __typename?: 'GA4CredentialsModel';
  measurementId: Scalars['String']['output'];
};

export type Ga4MetadataModel = {
  __typename?: 'GA4MetadataModel';
  productIdentifier: Scalars['String']['output'];
};

export type GetEmqScoreAverageAndTrendInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetEmqScoreDefaultAndAverageInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetEmqScoresByRangeInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type GetProfilesListResponse = {
  __typename?: 'GetProfilesListResponse';
  anonVisitorCount?: Maybe<Scalars['Int']['output']>;
  profiles: Array<Profile>;
};

export type GetSegmentUsersInput = {
  merchantId: Scalars['String']['input'];
  requesterId: Scalars['String']['input'];
  segmentId: Scalars['String']['input'];
};

export type GetSignedUrlOutput = {
  __typename?: 'GetSignedURLOutput';
  url: Scalars['String']['output'];
};

export type GetSignedUrlsOutput = {
  __typename?: 'GetSignedURLSOutput';
  urls: Array<Scalars['String']['output']>;
};

export type GoogleAdsConversionAction = {
  __typename?: 'GoogleAdsConversionAction';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GoogleAdsCredentials = {
  __typename?: 'GoogleAdsCredentials';
  customerId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
};

export type GoogleAdsCredentialsModel = {
  __typename?: 'GoogleAdsCredentialsModel';
  customerId: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
};

export type GoogleAdsCtids = {
  __typename?: 'GoogleAdsCtids';
  ctids: Array<CtidEntry>;
};

export type GoogleAdsCtidsInput = {
  ctids: Array<CtidEntryInput>;
};

export type GoogleAdsCtidsModel = {
  __typename?: 'GoogleAdsCtidsModel';
  ctids: Scalars['JSON']['output'];
};

export type GoogleAdsMetadataModel = {
  __typename?: 'GoogleAdsMetadataModel';
  contentType: Scalars['String']['output'];
  googleAdsCtids: GoogleAdsCtidsModel;
  productIdentifier: Scalars['String']['output'];
};

export enum IneligibilityCode {
  AllItemsClaimed = 'ALL_ITEMS_CLAIMED',
  ExternalRefundsOrReturns = 'EXTERNAL_REFUNDS_OR_RETURNS',
  NoEligibleFulfillments = 'NO_ELIGIBLE_FULFILLMENTS'
}

export type Integration = {
  __typename?: 'Integration';
  consentMode?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentials: IntegrationCredentials;
  filters: Array<Filter>;
  id: Scalars['String']['output'];
  metadata: Metadata;
  name: Scalars['String']['output'];
  smartQualify?: Maybe<Scalars['Boolean']['output']>;
  status: ConnectionStatus;
  statusMessage?: Maybe<Scalars['String']['output']>;
  type: IntegrationType;
  updatedAt: Scalars['DateTime']['output'];
};

export type IntegrationCredentials = AttentiveCredentials | Ga4Credentials | GoogleAdsCredentials | KlaviyoCredentials | MetaCredentials | PostscriptCredentials | RedoCredentials | SnapchatCredentials | TiktokCredentials;

export type IntegrationCredentialsUnion = AttentiveCredentialsModel | Ga4CredentialsModel | GoogleAdsCredentialsModel | KlaviyoCredentialsModel | MetaCredentialsModel | PostscriptCredentialsModel | RedoCredentialsModel | SendlaneCredentialsModel | SnapchatCredentialsModel | TikTokCredentialsModel | WebhookCredentialsModel;

export type IntegrationMetadataUnion = Ga4MetadataModel | GoogleAdsMetadataModel | MetaMetadataModel | SnapchatMetadataModel | TikTokMetadataModel;

export enum IntegrationType {
  Attentive = 'ATTENTIVE',
  Ga4 = 'GA4',
  Googleads = 'GOOGLEADS',
  Klaviyo = 'KLAVIYO',
  Meta = 'META',
  Postscript = 'POSTSCRIPT',
  Sendlane = 'SENDLANE',
  Snapchat = 'SNAPCHAT',
  Tiktok = 'TIKTOK',
  Unspecified = 'UNSPECIFIED'
}

export enum IntegrationTypeV2 {
  Attentive = 'ATTENTIVE',
  Ga4 = 'GA4',
  Googleads = 'GOOGLEADS',
  Klaviyo = 'KLAVIYO',
  Meta = 'META',
  Postscript = 'POSTSCRIPT',
  Redo = 'REDO',
  Sendlane = 'SENDLANE',
  Snapchat = 'SNAPCHAT',
  Tiktok = 'TIKTOK',
  Unspecified = 'UNSPECIFIED',
  Webhook = 'WEBHOOK'
}

export type IntegrationV2Properties = {
  __typename?: 'IntegrationV2Properties';
  consentMode?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  credentials?: Maybe<IntegrationCredentialsUnion>;
  findFiltersV2: Array<FilterV2>;
  id: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  metadata?: Maybe<IntegrationMetadataUnion>;
  name: Scalars['String']['output'];
  oneTimeSigningSecret?: Maybe<Scalars['String']['output']>;
  smartQualify?: Maybe<Scalars['Boolean']['output']>;
  status: ConnectionStatusV2;
  statusMessage?: Maybe<Scalars['String']['output']>;
  type: IntegrationTypeV2;
  updatedAt: Scalars['DateTime']['output'];
};

export type KlaviyoCredentials = {
  __typename?: 'KlaviyoCredentials';
  apiKey: Scalars['String']['output'];
};

export type KlaviyoCredentialsModel = {
  __typename?: 'KlaviyoCredentialsModel';
  apiKey: Scalars['String']['output'];
};

export type ListMetadata = {
  __typename?: 'ListMetadata';
  count: Scalars['Int']['output'];
};

export type ListProfilesFilters = {
  emailSource?: InputMaybe<EmailSource>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListProfilesPagination = {
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Merchant information */
export type Merchant = {
  __typename?: 'Merchant';
  /** Address line 1 */
  address1?: Maybe<Scalars['String']['output']>;
  /** Address line 2 */
  address2?: Maybe<Scalars['String']['output']>;
  /** Name of the business */
  businessName?: Maybe<Scalars['String']['output']>;
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Clerk organization ID */
  clerkOrgId?: Maybe<Scalars['String']['output']>;
  /** Clerk organization slug */
  clerkOrgSlug?: Maybe<Scalars['String']['output']>;
  /** Cloudflare custom hostname ID */
  cloudflareCustomHostnameId?: Maybe<Scalars['String']['output']>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dnsVerificationRecords: Array<DnsRecord>;
  domain?: Maybe<Scalars['String']['output']>;
  /** EIN number */
  einNumber?: Maybe<Scalars['String']['output']>;
  /** Whether consent is enabled */
  hasConsentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The shopify shop id for the merchant */
  id?: Maybe<Scalars['ID']['output']>;
  isDomainVerified: Scalars['Boolean']['output'];
  /** Merchant category */
  merchantCategory?: Maybe<Scalars['String']['output']>;
  /** Province or state */
  province?: Maybe<Scalars['String']['output']>;
  /** Timezone */
  timezone?: Maybe<Scalars['String']['output']>;
  /** TXT records name */
  txtRecordsName?: Maybe<Scalars['String']['output']>;
  /** TXT records value */
  txtRecordsValue?: Maybe<Scalars['String']['output']>;
  /** Last update timestamp */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Validation records name */
  validationRecordsName?: Maybe<Scalars['String']['output']>;
  /** Validation records value */
  validationRecordsValue?: Maybe<Scalars['String']['output']>;
  /** Name of the website */
  websiteName?: Maybe<Scalars['String']['output']>;
  /** URL of the website */
  websiteUrl?: Maybe<Scalars['String']['output']>;
  /** ZIP or postal code */
  zip?: Maybe<Scalars['String']['output']>;
};

export type MerchantEmqCheck = {
  __typename?: 'MerchantEmqCheck';
  hasBaseline: Scalars['Boolean']['output'];
  hasLast7Days: Scalars['Boolean']['output'];
};

export type MerchantModel = {
  __typename?: 'MerchantModel';
  billingAddress1?: Maybe<Scalars['String']['output']>;
  billingAddress2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
  billingZip?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  clerkOrgId: Scalars['String']['output'];
  emqCheck: MerchantEmqCheck;
  emqScoreEnabled: Scalars['Boolean']['output'];
  friendlyPaymentMethod?: Maybe<PaymentMethodModel>;
  hasAllPermissionsNeeded: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  merchantType: MerchantType;
  missingPermissions: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: MerchantStatus;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** The status of the merchant */
export enum MerchantStatus {
  Active = 'ACTIVE'
}

/** Merchant subscription information */
export type MerchantSubscription = {
  __typename?: 'MerchantSubscription';
  baseFeeCents: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  merchantId: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The type of the merchant */
export enum MerchantType {
  Consumer = 'CONSUMER',
  InternalTesting = 'INTERNAL_TESTING'
}

export type MetaCredentials = {
  __typename?: 'MetaCredentials';
  accessToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MetaCredentialsModel = {
  __typename?: 'MetaCredentialsModel';
  accessToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MetaMetadataModel = {
  __typename?: 'MetaMetadataModel';
  contentType: Scalars['String']['output'];
  productIdentifier: Scalars['String']['output'];
  tagDelivery?: Maybe<Scalars['String']['output']>;
};

export type Metadata = {
  __typename?: 'Metadata';
  contentType?: Maybe<ContentType>;
  googleAdsCtids?: Maybe<GoogleAdsCtids>;
  productIdentifier?: Maybe<ProductIdentifier>;
};

export type MetadataInput = {
  contentType: ContentType;
  googleAdsCtids?: InputMaybe<GoogleAdsCtidsInput>;
  productIdentifier: ProductIdentifier;
};

export type Metric = {
  __typename?: 'Metric';
  aggregate: Scalars['Float']['output'];
  aggregateMethod: AggregateMethod;
  chartUnit: ChartUnit;
  data: Array<Scalars['Float']['output']>;
  dateRange?: Maybe<DateRange>;
  labels: Array<Scalars['String']['output']>;
  timeRange?: Maybe<TimeRange>;
};

export type MetricCaptureRateFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Types of metrics that can be compared */
export enum MetricComparisonType {
  AnonVisitors = 'ANON_VISITORS',
  Revenue = 'REVENUE',
  Roi = 'ROI',
  TotalEvents = 'TOTAL_EVENTS'
}

export type MetricInput = {
  fromDate: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  merchantId: Scalars['ID']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  toDate: Scalars['String']['input'];
};

export type MetricsComparison = {
  __typename?: 'MetricsComparison';
  absoluteChange: Scalars['Float']['output'];
  currentPeriod: Metric;
  percentageChange: Scalars['Float']['output'];
  previousPeriod: Metric;
};

export type MetricsComparisonInput = {
  fromDate: Scalars['String']['input'];
  merchantId: Scalars['ID']['input'];
  metricType: MetricComparisonType;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  toDate: Scalars['String']['input'];
};

export type MetricsResponse = {
  __typename?: 'MetricsResponse';
  anonVisitorCount: Scalars['Float']['output'];
  totalProfiles: Scalars['Float']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  ShopifyProduct: FriendlyProductUpdateResult;
  addContextualUsersToOrganization: Scalars['JSON']['output'];
  adminApproveClaim: ClaimModel;
  adminCreateMerchantSubscription: MerchantSubscription;
  adminCreateOrUpdateCustomAppCreds: CustomAppCredsModel;
  adminDeleteCustomAppCreds: Scalars['Boolean']['output'];
  adminDeleteMerchantSubscription: Scalars['Boolean']['output'];
  adminDenyClaim: ClaimModel;
  adminUpdateMerchantEmqScoreEnabled: Scalars['Boolean']['output'];
  adminUpdateMerchantSubscription: MerchantSubscription;
  approveClaimItem: ClaimModel;
  claimOrder: Scalars['String']['output'];
  createCampaign: Campaign;
  createDraftShopifyProduct: Scalars['JSON']['output'];
  createIntegration: Integration;
  createIntegrationV2: IntegrationV2Properties;
  createMerchantSubscription: MerchantSubscription;
  createNewShoppingDomainMapping: Scalars['Boolean']['output'];
  createSegment: Scalars['String']['output'];
  createSetupIntent: SetupIntentModel;
  createSignedUrl: CreateSignedUrlResponse;
  createSignedUrlClaims: CreateSignedUrlResponse;
  deleteCampaign: Campaign;
  deleteIntegration: Scalars['ID']['output'];
  deleteIntegrationV2: Scalars['ID']['output'];
  deleteSegment: Scalars['Boolean']['output'];
  denyClaimItem: ClaimModel;
  duplicateSegment: Scalars['String']['output'];
  googleAdsEnsureConversionActions: Array<CtidEntry>;
  initiateClaim: ClaimAuthResponse;
  liveRegisterDomain: Scalars['String']['output'];
  markOnboardingComplete: Scalars['Boolean']['output'];
  processExchange: ClaimModel;
  processRefund: ClaimModel;
  publishShopifyProduct: Scalars['JSON']['output'];
  runScheduleLoop: Scalars['JSON']['output'];
  sendCampaignPreview: Scalars['Boolean']['output'];
  sendSms: Scalars['String']['output'];
  setConsent: Merchant;
  setStatusAsScheduled: Campaign;
  syncKlaviyoData: Scalars['String']['output'];
  syncKlaviyoFlowsForAllMerchants: Scalars['String']['output'];
  syncShopifyData: Scalars['String']['output'];
  testAlerts: Scalars['String']['output'];
  updateBillingInformation: MerchantModel;
  updateCampaign: Campaign;
  updateCurrentMerchant: Merchant;
  updateEMQScore: EmqScoreResult;
  updateFriendlyBrandSettings: FriendlyBrandSettingsResult;
  updateFriendlyProductImage: FriendlyProductUpdateResult;
  updateGa4Credentials: Integration;
  updateGoogleAdsCredentials: Integration;
  updateIntegrationConsentMode: Integration;
  updateIntegrationConsentModeV2: IntegrationV2Properties;
  updateIntegrationCredentialsV2: IntegrationV2Properties;
  updateIntegrationEvents: Integration;
  updateIntegrationEventsV2: IntegrationV2Properties;
  updateIntegrationMetadata: Integration;
  updateIntegrationMetadataV2: IntegrationV2Properties;
  updateIntegrationSmartQualify: Integration;
  updateIntegrationStatus: Integration;
  updateIntegrationStatusV2: IntegrationV2Properties;
  updateIntegrationTransactionPropertyFilters: Integration;
  updateKlaviyoCredentials: Integration;
  updateMetaCredentials: Integration;
  updatePostscriptCredentials: Integration;
  updatePropertyFiltersV2: IntegrationV2Properties;
  updateSegment: Scalars['String']['output'];
  updateShopifyProductVariants: Scalars['JSON']['output'];
  updateSmartQualifyV2: IntegrationV2Properties;
  updateSnapchatCredentials: Integration;
  updateTiktokCredentials: Integration;
  verifyCnameRecord: DnsRecord;
  verifyDomain: Merchant;
  verifyMicrodeposits: VerifyMicrodepositsModel;
  verifyTxtRecord: Array<DnsRecord>;
};


export type MutationShopifyProductArgs = {
  merchantId: Scalars['String']['input'];
};


export type MutationAddContextualUsersToOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdminApproveClaimArgs = {
  approvalNote: Scalars['String']['input'];
  claimId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationAdminCreateMerchantSubscriptionArgs = {
  baseFeeCents: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  merchantId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type MutationAdminCreateOrUpdateCustomAppCredsArgs = {
  appHandle: Scalars['String']['input'];
  appName: Scalars['String']['input'];
  clientId: Scalars['String']['input'];
  clientSecret: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationAdminDeleteCustomAppCredsArgs = {
  merchantId: Scalars['String']['input'];
};


export type MutationAdminDeleteMerchantSubscriptionArgs = {
  merchantId: Scalars['String']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type MutationAdminDenyClaimArgs = {
  claimDenyNote: Scalars['String']['input'];
  claimId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationAdminUpdateMerchantEmqScoreEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationAdminUpdateMerchantSubscriptionArgs = {
  baseFeeCents: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  merchantId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  subscriptionId: Scalars['String']['input'];
};


export type MutationApproveClaimItemArgs = {
  claimId: Scalars['String']['input'];
  claimItemId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationClaimOrderArgs = {
  createPortalClaim: CreatePortalClaim;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateDraftShopifyProductArgs = {
  shopDomain: Scalars['String']['input'];
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateIntegrationV2Args = {
  input: CreateIntegrationInputV2;
};


export type MutationCreateMerchantSubscriptionArgs = {
  baseFeeCents: Scalars['Float']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type MutationCreateNewShoppingDomainMappingArgs = {
  merchantId: Scalars['String']['input'];
  subDomain: Scalars['String']['input'];
};


export type MutationCreateSegmentArgs = {
  input: CreateSegmentInput;
};


export type MutationCreateSignedUrlArgs = {
  input: CreateSignedUrlInput;
};


export type MutationCreateSignedUrlClaimsArgs = {
  input: CreateSignedUrlInput;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIntegrationV2Args = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSegmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDenyClaimItemArgs = {
  claimId: Scalars['String']['input'];
  claimItemId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationDuplicateSegmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationGoogleAdsEnsureConversionActionsArgs = {
  customerId: Scalars['String']['input'];
  events: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationInitiateClaimArgs = {
  email: Scalars['String']['input'];
  friendlySubdomain: Scalars['String']['input'];
  merchantId?: InputMaybe<Scalars['String']['input']>;
  orderNumber: Scalars['String']['input'];
};


export type MutationLiveRegisterDomainArgs = {
  domain: Scalars['String']['input'];
};


export type MutationProcessExchangeArgs = {
  claimExchangeId: Scalars['String']['input'];
  claimId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationProcessRefundArgs = {
  claimId: Scalars['String']['input'];
  claimRefundId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationPublishShopifyProductArgs = {
  productId: Scalars['String']['input'];
  shopDomain: Scalars['String']['input'];
};


export type MutationSendCampaignPreviewArgs = {
  input: SendCampaignPreviewInput;
};


export type MutationSendSmsArgs = {
  merchantId?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};


export type MutationSetConsentArgs = {
  consent: Scalars['Boolean']['input'];
};


export type MutationSetStatusAsScheduledArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncKlaviyoDataArgs = {
  api_key: Scalars['String']['input'];
  merchant_id: Scalars['String']['input'];
};


export type MutationSyncShopifyDataArgs = {
  access_token: Scalars['String']['input'];
  merchant_id: Scalars['String']['input'];
  shop_url: Scalars['String']['input'];
};


export type MutationTestAlertsArgs = {
  message: Scalars['String']['input'];
};


export type MutationUpdateBillingInformationArgs = {
  input: UpdateBillingInfo;
};


export type MutationUpdateCampaignArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCampaignInput;
};


export type MutationUpdateCurrentMerchantArgs = {
  input: UpdateCurrentMerchant;
};


export type MutationUpdateEmqScoreArgs = {
  input: EmqScoreInput;
  type: EmqScoreType;
};


export type MutationUpdateFriendlyBrandSettingsArgs = {
  input: FriendlyBrandSettingsInput;
};


export type MutationUpdateGa4CredentialsArgs = {
  id: Scalars['ID']['input'];
  measurementId: Scalars['String']['input'];
};


export type MutationUpdateGoogleAdsCredentialsArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationUpdateIntegrationConsentModeArgs = {
  consentMode: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateIntegrationConsentModeV2Args = {
  consentMode: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateIntegrationCredentialsV2Args = {
  credentials: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateIntegrationEventsArgs = {
  events: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
};


export type MutationUpdateIntegrationEventsV2Args = {
  events: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateIntegrationMetadataArgs = {
  id: Scalars['ID']['input'];
  metadata: MetadataInput;
};


export type MutationUpdateIntegrationMetadataV2Args = {
  id: Scalars['ID']['input'];
  metadata: Scalars['JSON']['input'];
};


export type MutationUpdateIntegrationSmartQualifyArgs = {
  id: Scalars['ID']['input'];
  smartQualify: Scalars['Boolean']['input'];
};


export type MutationUpdateIntegrationStatusArgs = {
  id: Scalars['ID']['input'];
  status: ConnectionStatus;
};


export type MutationUpdateIntegrationStatusV2Args = {
  id: Scalars['ID']['input'];
  status: ConnectionStatusV2;
};


export type MutationUpdateIntegrationTransactionPropertyFiltersArgs = {
  input: UpdateOrdersCreatePropertyFiltersInput;
};


export type MutationUpdateKlaviyoCredentialsArgs = {
  apiKey: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateMetaCredentialsArgs = {
  accessToken: Scalars['String']['input'];
  datasetId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdatePostscriptCredentialsArgs = {
  id: Scalars['ID']['input'];
  shopToken: Scalars['String']['input'];
};


export type MutationUpdatePropertyFiltersV2Args = {
  id: Scalars['ID']['input'];
  input: Array<PropertyFilterInputV2>;
};


export type MutationUpdateSegmentArgs = {
  input: CreateSegmentInput;
  segment_id: Scalars['String']['input'];
};


export type MutationUpdateShopifyProductVariantsArgs = {
  productId: Scalars['String']['input'];
  requestProductVariants: Array<UpdateProductVariant>;
  shopDomain: Scalars['String']['input'];
};


export type MutationUpdateSmartQualifyV2Args = {
  id: Scalars['ID']['input'];
  smartQualify: Scalars['Boolean']['input'];
};


export type MutationUpdateSnapchatCredentialsArgs = {
  accessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  snapchatId: Scalars['String']['input'];
};


export type MutationUpdateTiktokCredentialsArgs = {
  accessToken: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  tiktokId: Scalars['String']['input'];
};


export type MutationVerifyDomainArgs = {
  websiteUrl: Scalars['String']['input'];
};


export type MutationVerifyMicrodepositsArgs = {
  input: VerifyMicrodepositsInput;
};

export enum Operator {
  Contains = 'CONTAINS'
}

export enum OperatorV2 {
  Contains = 'CONTAINS'
}

export type OrderClaimModel = {
  __typename?: 'OrderClaimModel';
  billingAddress?: Maybe<Address>;
  dutiesIncluded: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalOrderId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  fulfillments: Array<FulfillmentClaimModel>;
  isFriendly: Scalars['Boolean']['output'];
  isRefundedInternally: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantUrl?: Maybe<Scalars['String']['output']>;
  orderCancelledAt?: Maybe<Scalars['DateTime']['output']>;
  orderClosedAt?: Maybe<Scalars['DateTime']['output']>;
  orderCreatedAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderUpdatedAt: Scalars['DateTime']['output'];
  shippingAddress?: Maybe<Address>;
  shopCurrency?: Maybe<Scalars['String']['output']>;
  shopProtectionFeeCents: Scalars['Float']['output'];
  taxesIncluded: Scalars['Boolean']['output'];
  totalShopDiscountsCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingDiscountCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingPriceCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingTaxCents: Scalars['Float']['output'];
  totalShopLineItemShippingDiscountCents: Scalars['Float']['output'];
  totalShopLineItemShippingPriceCents: Scalars['Float']['output'];
  totalShopLineItemShippingTaxCents: Scalars['Float']['output'];
  totalShopPriceCents: Scalars['Float']['output'];
  totalShopRefundedAmountCents: Scalars['Float']['output'];
  totalShopShippingRefundCents: Scalars['Float']['output'];
  totalShopSubtotalCents: Scalars['Float']['output'];
  totalShopTaxCents: Scalars['Float']['output'];
};

export type OrderItemModel = {
  __typename?: 'OrderItemModel';
  externalOrderId: Scalars['String']['output'];
  externalOrderItemId: Scalars['String']['output'];
  externalProductId?: Maybe<Scalars['String']['output']>;
  externalVariantId?: Maybe<Scalars['String']['output']>;
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  fulfilledQuantity: Scalars['Int']['output'];
  isGiftCard: Scalars['Boolean']['output'];
  merchantId: Scalars['String']['output'];
  originalQuantity: Scalars['Int']['output'];
  postProcessedQuantity: Scalars['Int']['output'];
  priceCents: Scalars['Float']['output'];
  quantity: Scalars['Int']['output'];
  requiresShipping: Scalars['Boolean']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiscountsCents: Scalars['Float']['output'];
  totalTaxCents: Scalars['Float']['output'];
  unavailableQuantity: Scalars['Int']['output'];
  variantTitle?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
  weightInGrams?: Maybe<Scalars['Float']['output']>;
};

export type OrderSummaryModel = {
  __typename?: 'OrderSummaryModel';
  billingAddress?: Maybe<Address>;
  dutiesIncluded: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalOrderId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  friendlyCreatedAt: Scalars['DateTime']['output'];
  friendlyUpdatedAt: Scalars['DateTime']['output'];
  isFriendly: Scalars['Boolean']['output'];
  isRefundedInternally: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantUrl?: Maybe<Scalars['String']['output']>;
  orderCancelledAt?: Maybe<Scalars['DateTime']['output']>;
  orderClosedAt?: Maybe<Scalars['DateTime']['output']>;
  orderCreatedAt: Scalars['DateTime']['output'];
  orderName: Scalars['String']['output'];
  orderNumber: Scalars['String']['output'];
  orderUpdatedAt: Scalars['DateTime']['output'];
  shippingAddress?: Maybe<Address>;
  shopCurrency?: Maybe<Scalars['String']['output']>;
  shopProtectionFeeCents: Scalars['Float']['output'];
  taxesIncluded: Scalars['Boolean']['output'];
  totalShopDiscountsCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingDiscountCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingPriceCents: Scalars['Float']['output'];
  totalShopInactiveLineItemShippingTaxCents: Scalars['Float']['output'];
  totalShopLineItemShippingDiscountCents: Scalars['Float']['output'];
  totalShopLineItemShippingPriceCents: Scalars['Float']['output'];
  totalShopLineItemShippingTaxCents: Scalars['Float']['output'];
  totalShopPriceCents: Scalars['Float']['output'];
  totalShopRefundedAmountCents: Scalars['Float']['output'];
  totalShopShippingRefundCents: Scalars['Float']['output'];
  totalShopSubtotalCents: Scalars['Float']['output'];
  totalShopTaxCents: Scalars['Float']['output'];
};

export type PaymentMethodModel = {
  __typename?: 'PaymentMethodModel';
  bankName?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  expMonth?: Maybe<Scalars['Float']['output']>;
  expYear?: Maybe<Scalars['Float']['output']>;
  externalPaymentMethodId?: Maybe<Scalars['String']['output']>;
  externalSetupIntentId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  last4?: Maybe<Scalars['String']['output']>;
  merchantId: Scalars['String']['output'];
  paymentMethodCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  setupIntentCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  setupIntentStatus?: Maybe<SetupIntentStatus>;
  updatedAt: Scalars['DateTime']['output'];
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The type of payment method */
export enum PaymentMethodType {
  Card = 'CARD',
  UsBankAccount = 'US_BANK_ACCOUNT'
}

export type PostscriptCredentials = {
  __typename?: 'PostscriptCredentials';
  shopToken: Scalars['String']['output'];
};

export type PostscriptCredentialsModel = {
  __typename?: 'PostscriptCredentialsModel';
  shopToken: Scalars['String']['output'];
};

export enum ProductIdentifier {
  ProductId = 'PRODUCT_ID',
  ProductSku = 'PRODUCT_SKU',
  Unspecified = 'UNSPECIFIED',
  VariantId = 'VARIANT_ID'
}

export type Profile = {
  __typename?: 'Profile';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  lastSeen: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  source: ProfileSource;
};

/** Source of the profile data */
export enum ProfileSource {
  ProfileSource_5X5 = 'PROFILE_SOURCE_5X5',
  ProfileSourceContextual = 'PROFILE_SOURCE_CONTEXTUAL',
  ProfileSourceUnspecified = 'PROFILE_SOURCE_UNSPECIFIED',
  ProfileSourceVoldemort = 'PROFILE_SOURCE_VOLDEMORT'
}

export type ProfileV2Response = {
  __typename?: 'ProfileV2Response';
  email?: Maybe<Scalars['String']['output']>;
  emailOptIn?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstSeen: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  lastSeen: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type PropertyFilter = {
  __typename?: 'PropertyFilter';
  operator: Operator;
  prop: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type PropertyFilterInput = {
  operator: Operator;
  prop: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type PropertyFilterInputV2 = {
  operator: OperatorV2;
  prop: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

export type PropertyFilterV2 = {
  __typename?: 'PropertyFilterV2';
  operator: OperatorV2;
  prop: Scalars['String']['output'];
  value: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminFindClaims: FindClaims;
  adminGetAllCustomAppCreds: Array<CustomAppCredsModel>;
  adminGetMerchant: MerchantModel;
  adminGetMerchantSubscriptions: Array<MerchantSubscription>;
  campaign: Campaign;
  campaigns: Array<Campaign>;
  claimOrder: OrderClaimModel;
  currentMerchant: Merchant;
  estimateSegmentCount: Scalars['Float']['output'];
  estimateSegmentDefinition: Scalars['Float']['output'];
  fetchShopifyProfilesBatch: Scalars['JSON']['output'];
  getActiveUniqueProfileMetrics: ActiveUniqueProfileMetricsResponse;
  getAllContextualMembers: Scalars['JSON']['output'];
  getAllSegmentMetadataForMerchant: Array<FindSegmentQueryResult>;
  getAnonVisitorsCaptured: Metric;
  getConversionMonitoringMetrics: Metric;
  getCurrentShopifyInfo: Scalars['JSON']['output'];
  getEMQBaselineScore: EmqBaselineScoreResult;
  getEMQScore: EmqQueryResult;
  getEMQScoreAverageAndTrend: EmqScoreAverageAndTrend;
  getEMQScoreDefaultAndAverageForTimePeriod: Array<DefaultAndAverageRow>;
  getEMQScoresByDateRange: Array<DailyEmqScore>;
  getEmailCaptureRate: EmailCaptureRateResponse;
  getFlowsRevenue: Metric;
  getFriendlyBrand?: Maybe<FriendlyBrand>;
  getLifecycleRevenue: Metric;
  getLifetimeROI?: Maybe<Scalars['Float']['output']>;
  getLifetimeRevenue: Scalars['Float']['output'];
  getMerchantTimezone: Scalars['String']['output'];
  getMetricsComparison: MetricsComparison;
  getOrganizationMembers: Scalars['JSON']['output'];
  getProfileMetrics: MetricsResponse;
  getProfilesList: GetProfilesListResponse;
  getScheduledCampaigns: Scalars['JSON']['output'];
  getSegmentMetadataBySegmentId: FindSegmentQueryResult;
  getSegmentUsers: Array<SegmentUserDto>;
  getServerEventLogs: Array<Metric>;
  getShopifyProduct: Scalars['JSON']['output'];
  getSignedUrl: GetSignedUrlOutput;
  getSignedUrlAdmin: GetSignedUrlOutput;
  getSignedUrlClaims: GetSignedUrlOutput;
  getSignedUrlsAdmin: GetSignedUrlsOutput;
  getTotalEventsTracked: Array<Metric>;
  getVisitorsRecognized: Metric;
  googleAdsGetConversionActions: Array<GoogleAdsConversionAction>;
  health: Scalars['String']['output'];
  helloWorldTemporal: Scalars['String']['output'];
  integration: Integration;
  integrationV2: IntegrationV2Properties;
  integrations: Array<Integration>;
  integrationsV2: Array<IntegrationV2Properties>;
  listAdminMerchants: Array<MerchantModel>;
  listProfiles: Array<ProfileV2Response>;
  lookupClaimMerchant?: Maybe<FindClaimByIdResult>;
  lookupCustomerClaim?: Maybe<FindClaimByIdResult>;
  lookupSubDomain?: Maybe<Scalars['String']['output']>;
  merchant: MerchantModel;
  merchantFindClaims: FindClaims;
  merchantSubscriptions: Array<MerchantSubscription>;
  testError: Scalars['String']['output'];
  testErrorWithUser: Scalars['String']['output'];
  testQuery: Scalars['String']['output'];
  verifyClaimToken: Scalars['Boolean']['output'];
};


export type QueryAdminFindClaimsArgs = {
  adminFindClaimsQuery: ClaimAdminListQueryInput;
};


export type QueryAdminGetMerchantArgs = {
  merchantId: Scalars['String']['input'];
};


export type QueryAdminGetMerchantSubscriptionsArgs = {
  merchantId: Scalars['String']['input'];
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  includeDeleted?: Scalars['Boolean']['input'];
};


export type QueryEstimateSegmentCountArgs = {
  input: GetSegmentUsersInput;
};


export type QueryEstimateSegmentDefinitionArgs = {
  input: EstimateSegmentDefinitionInput;
};


export type QueryGetActiveUniqueProfileMetricsArgs = {
  filters: MetricCaptureRateFilter;
};


export type QueryGetAllSegmentMetadataForMerchantArgs = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetAnonVisitorsCapturedArgs = {
  input: MetricInput;
};


export type QueryGetConversionMonitoringMetricsArgs = {
  input: MetricInput;
};


export type QueryGetEmqBaselineScoreArgs = {
  merchantId: Scalars['String']['input'];
};


export type QueryGetEmqScoreArgs = {
  end_date: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
  source: EmqScoreSource;
  start_date: Scalars['String']['input'];
};


export type QueryGetEmqScoreAverageAndTrendArgs = {
  input: GetEmqScoreAverageAndTrendInput;
};


export type QueryGetEmqScoreDefaultAndAverageForTimePeriodArgs = {
  input: GetEmqScoreDefaultAndAverageInput;
};


export type QueryGetEmqScoresByDateRangeArgs = {
  input: GetEmqScoresByRangeInput;
};


export type QueryGetEmailCaptureRateArgs = {
  filters: MetricCaptureRateFilter;
};


export type QueryGetFlowsRevenueArgs = {
  input: MetricInput;
};


export type QueryGetFriendlyBrandArgs = {
  merchantId?: InputMaybe<Scalars['String']['input']>;
  publicImage?: Scalars['Boolean']['input'];
};


export type QueryGetLifecycleRevenueArgs = {
  input: MetricInput;
};


export type QueryGetLifetimeRoiArgs = {
  merchantId: Scalars['ID']['input'];
  refresh?: Scalars['Boolean']['input'];
};


export type QueryGetLifetimeRevenueArgs = {
  merchantId: Scalars['ID']['input'];
  refresh?: Scalars['Boolean']['input'];
};


export type QueryGetMerchantTimezoneArgs = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMetricsComparisonArgs = {
  input: MetricsComparisonInput;
};


export type QueryGetOrganizationMembersArgs = {
  organizationId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProfileMetricsArgs = {
  input: MetricInput;
};


export type QueryGetProfilesListArgs = {
  input: MetricInput;
};


export type QueryGetSegmentMetadataBySegmentIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetSegmentUsersArgs = {
  input: GetSegmentUsersInput;
};


export type QueryGetServerEventLogsArgs = {
  input: MetricInput;
};


export type QueryGetShopifyProductArgs = {
  productId: Scalars['String']['input'];
  shopDomain: Scalars['String']['input'];
};


export type QueryGetSignedUrlArgs = {
  gcsPath: Scalars['String']['input'];
};


export type QueryGetSignedUrlAdminArgs = {
  gcsPath: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type QueryGetSignedUrlClaimsArgs = {
  gcsPath: Scalars['String']['input'];
};


export type QueryGetSignedUrlsAdminArgs = {
  gcsPaths: Array<Scalars['String']['input']>;
  merchantId: Scalars['String']['input'];
};


export type QueryGetTotalEventsTrackedArgs = {
  input: MetricInput;
};


export type QueryGetVisitorsRecognizedArgs = {
  input: MetricInput;
};


export type QueryGoogleAdsGetConversionActionsArgs = {
  customerId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryHelloWorldTemporalArgs = {
  name: Scalars['String']['input'];
};


export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIntegrationV2Args = {
  id: Scalars['ID']['input'];
};


export type QueryListProfilesArgs = {
  filters: ListProfilesFilters;
  pagination: ListProfilesPagination;
};


export type QueryLookupClaimMerchantArgs = {
  claimId: Scalars['String']['input'];
};


export type QueryLookupCustomerClaimArgs = {
  claimId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
};


export type QueryLookupSubDomainArgs = {
  subdomain: Scalars['String']['input'];
};


export type QueryMerchantFindClaimsArgs = {
  merchantFindClaimsQuery: ClaimMerchantListQueryInput;
};


export type QueryMerchantSubscriptionsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryTestErrorArgs = {
  message: Scalars['String']['input'];
};


export type QueryTestErrorWithUserArgs = {
  message: Scalars['String']['input'];
};


export type QueryTestQueryArgs = {
  shouldFail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryVerifyClaimTokenArgs = {
  token: Scalars['String']['input'];
};

export type RedoCredentials = {
  __typename?: 'RedoCredentials';
  redoAccessToken: Scalars['String']['output'];
  redoStoreId: Scalars['String']['output'];
  redoWidgetId?: Maybe<Scalars['String']['output']>;
};

export type RedoCredentialsModel = {
  __typename?: 'RedoCredentialsModel';
  redoAccessToken: Scalars['String']['output'];
  redoStoreId: Scalars['String']['output'];
  redoWidgetId?: Maybe<Scalars['String']['output']>;
};

export enum RefundStatus {
  Created = 'CREATED',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Removed = 'REMOVED'
}

export type SegmentDefinition = {
  __typename?: 'SegmentDefinition';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groups: Array<ConditionGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rootOperator: SegmentOperator;
  updatedAt: Scalars['DateTime']['output'];
};

export type SegmentDefinitionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groups: Array<ConditionGroupInput>;
  name: Scalars['String']['input'];
  rootOperator: SegmentOperator;
};

export type SegmentMembershipCondition = ConditionInterface & {
  __typename?: 'SegmentMembershipCondition';
  conditionType: ConditionTypeEnum;
  id?: Maybe<Scalars['ID']['output']>;
  isMember: Scalars['Boolean']['output'];
  segmentId: Scalars['String']['output'];
};

/** Defines how groups or conditions are combined (AND/OR) */
export enum SegmentOperator {
  And = 'AND',
  Or = 'OR'
}

export type SegmentTimeRange = {
  __typename?: 'SegmentTimeRange';
  fromTime: Scalars['DateTime']['output'];
  toTime: Scalars['DateTime']['output'];
};

export type SegmentUserDto = {
  __typename?: 'SegmentUserDto';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<ContactPreferencesDto>;
  userId: Scalars['String']['output'];
};

export type Segments = {
  __typename?: 'Segments';
  exclude: Array<Scalars['String']['output']>;
  include: Array<Scalars['String']['output']>;
};

export type SegmentsInput = {
  exclude: Array<Scalars['String']['input']>;
  include: Array<Scalars['String']['input']>;
};

export type SendCampaignPreviewInput = {
  campaignId: Scalars['ID']['input'];
  recipients: Array<Scalars['String']['input']>;
  variantId?: InputMaybe<Scalars['ID']['input']>;
};

export type SendlaneCredentialsModel = {
  __typename?: 'SendlaneCredentialsModel';
  apiKey: Scalars['String']['output'];
  integrationToken: Scalars['String']['output'];
};

export type SetupIntentModel = {
  __typename?: 'SetupIntentModel';
  clientSecret: Scalars['String']['output'];
  nextActionType?: Maybe<Scalars['String']['output']>;
  setupIntentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** The status of the setup intent */
export enum SetupIntentStatus {
  Cancelled = 'CANCELLED',
  Processing = 'PROCESSING',
  RequiresAction = 'REQUIRES_ACTION',
  RequiresConfirmation = 'REQUIRES_CONFIRMATION',
  RequiresPaymentMethod = 'REQUIRES_PAYMENT_METHOD',
  Succeeded = 'SUCCEEDED'
}

export type SnapchatCredentials = {
  __typename?: 'SnapchatCredentials';
  accessToken: Scalars['String']['output'];
  snapchatId: Scalars['String']['output'];
};

export type SnapchatCredentialsModel = {
  __typename?: 'SnapchatCredentialsModel';
  accessToken: Scalars['String']['output'];
  snapchatId: Scalars['String']['output'];
};

export type SnapchatMetadataModel = {
  __typename?: 'SnapchatMetadataModel';
  contentType: Scalars['String']['output'];
  productIdentifier: Scalars['String']['output'];
  tagDelivery?: Maybe<Scalars['String']['output']>;
};

export enum SupportedUserProperty {
  Language = 'LANGUAGE',
  State = 'STATE',
  Timezone = 'TIMEZONE',
  Unspecified = 'UNSPECIFIED'
}

export type TikTokCredentialsModel = {
  __typename?: 'TikTokCredentialsModel';
  accessToken: Scalars['String']['output'];
  tiktokId: Scalars['String']['output'];
};

export type TikTokMetadataModel = {
  __typename?: 'TikTokMetadataModel';
  contentType: Scalars['String']['output'];
  productIdentifier: Scalars['String']['output'];
  tagDelivery?: Maybe<Scalars['String']['output']>;
};

export type TiktokCredentials = {
  __typename?: 'TiktokCredentials';
  accessToken: Scalars['String']['output'];
  tiktokId: Scalars['String']['output'];
};

export type TimeBoundary = {
  __typename?: 'TimeBoundary';
  conversionWindow?: Maybe<ConversionWindow>;
  timeRange?: Maybe<SegmentTimeRange>;
  type: TimeBoundaryType;
};

export enum TimeBoundaryType {
  AnyTime = 'ANY_TIME',
  ConversionWindow = 'CONVERSION_WINDOW',
  TimeRange = 'TIME_RANGE'
}

export type TimeRange = {
  __typename?: 'TimeRange';
  fromTime: Scalars['String']['output'];
  toTime: Scalars['String']['output'];
};

export type UpdateBillingInfo = {
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  billingCity?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingState?: InputMaybe<Scalars['String']['input']>;
  billingZip?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCampaignInput = {
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduled?: InputMaybe<Scalars['JSON']['input']>;
  segments?: InputMaybe<UpdateCampaignSegmentsInput>;
  status?: InputMaybe<CampaignStatus>;
  variants?: InputMaybe<Array<UpdateCampaignVariantInput>>;
};

export type UpdateCampaignSegmentsInput = {
  exclude: Array<Scalars['String']['input']>;
  include: Array<Scalars['String']['input']>;
};

export type UpdateCampaignVariantInput = {
  channel?: InputMaybe<Channel>;
  content?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  splitWeight?: InputMaybe<Scalars['Float']['input']>;
  variantName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCurrentMerchant = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  einNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  merchantCategory?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  websiteName?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrdersCreatePropertyFiltersInput = {
  id: Scalars['ID']['input'];
  propertyFilters: Array<PropertyFilterInput>;
};

export type UpdateProductVariant = {
  price: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UserPropertyCondition = ConditionInterface & {
  __typename?: 'UserPropertyCondition';
  boolValue?: Maybe<Scalars['Boolean']['output']>;
  comparisonOperator: ComparisonOperator;
  conditionType: ConditionTypeEnum;
  floatValue?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  intValue?: Maybe<Scalars['Int']['output']>;
  propertyName: SupportedUserProperty;
  stringArrayValue?: Maybe<Array<Scalars['String']['output']>>;
  stringValue?: Maybe<Scalars['String']['output']>;
};

export type VerifyMicrodepositsInput = {
  amounts: Array<Scalars['Int']['input']>;
  setupIntentId: Scalars['String']['input'];
};

export type VerifyMicrodepositsModel = {
  __typename?: 'VerifyMicrodepositsModel';
  isVerified: Scalars['Boolean']['output'];
  paymentMethodId?: Maybe<Scalars['String']['output']>;
  setupIntentId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type WebhookCredentialsModel = {
  __typename?: 'WebhookCredentialsModel';
  webhookUrl: Scalars['String']['output'];
};

export type GetMerchantTimezoneQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
}>;


export type GetMerchantTimezoneQuery = { __typename?: 'Query', getMerchantTimezone: string };

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', createCampaign: { __typename?: 'Campaign', campaignId: string, merchantId: string, name: string, status: CampaignStatus, createdBy: string, createdAt: string, updatedAt: string, scheduled?: any | null, generatedAt?: string | null, metadata?: any | null, segments: { __typename?: 'Segments', include: Array<string>, exclude: Array<string> }, variants: Array<{ __typename?: 'CampaignVariant', variantId: string, campaignId: string, channel: Channel, variantName: string, splitWeight: number, content?: any | null, metadata?: any | null, createdAt: string, updatedAt: string }> } };

export type SetStatusAsScheduledMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type SetStatusAsScheduledMutation = { __typename?: 'Mutation', setStatusAsScheduled: { __typename?: 'Campaign', campaignId: string, merchantId: string, name: string, status: CampaignStatus, createdBy: string, createdAt: string, updatedAt: string, scheduled?: any | null, generatedAt?: string | null, metadata?: any | null, segments: { __typename?: 'Segments', include: Array<string>, exclude: Array<string> }, variants: Array<{ __typename?: 'CampaignVariant', variantId: string, campaignId: string, channel: Channel, variantName: string, splitWeight: number, content?: any | null, metadata?: any | null, createdAt: string, updatedAt: string }> } };

export type UpdateCampaignMutationVariables = Exact<{
  updateCampaignId: Scalars['ID']['input'];
  input: UpdateCampaignInput;
}>;


export type UpdateCampaignMutation = { __typename?: 'Mutation', updateCampaign: { __typename: 'Campaign', campaignId: string, merchantId: string, name: string, status: CampaignStatus, createdBy: string, createdAt: string, updatedAt: string, scheduled?: any | null, generatedAt?: string | null, metadata?: any | null, segments: { __typename: 'Segments', include: Array<string>, exclude: Array<string> }, variants: Array<{ __typename: 'CampaignVariant', variantId: string, campaignId: string, channel: Channel, variantName: string, splitWeight: number, content?: any | null, metadata?: any | null, createdAt: string, updatedAt: string }> } };

export type DeleteCampaignMutationVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type DeleteCampaignMutation = { __typename?: 'Mutation', deleteCampaign: { __typename?: 'Campaign', campaignId: string, name: string, status: CampaignStatus } };

export type SendCampaignPreviewMutationVariables = Exact<{
  input: SendCampaignPreviewInput;
}>;


export type SendCampaignPreviewMutation = { __typename?: 'Mutation', sendCampaignPreview: boolean };

export type UpdateCredentialsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  credentials: Scalars['JSON']['input'];
}>;


export type UpdateCredentialsMutation = { __typename?: 'Mutation', updateIntegrationCredentialsV2: { __typename?: 'IntegrationV2Properties', id: string, oneTimeSigningSecret?: string | null, credentials?: { __typename?: 'AttentiveCredentialsModel', attentiveApiKey: string } | { __typename?: 'GA4CredentialsModel', measurementId: string } | { __typename?: 'GoogleAdsCredentialsModel', customerId: string, merchantId: string } | { __typename?: 'KlaviyoCredentialsModel', apiKey: string } | { __typename?: 'MetaCredentialsModel', accessToken: string, id: string } | { __typename?: 'PostscriptCredentialsModel', shopToken: string } | { __typename?: 'RedoCredentialsModel', redoAccessToken: string, redoStoreId: string, redoWidgetId?: string | null } | { __typename?: 'SendlaneCredentialsModel', apiKey: string, integrationToken: string } | { __typename?: 'SnapchatCredentialsModel', accessToken: string, snapchatId: string } | { __typename?: 'TikTokCredentialsModel', accessToken: string, tiktokId: string } | { __typename?: 'WebhookCredentialsModel', webhookUrl: string } | null } };

export type UpdateGoogleAdsCredentialsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerId: Scalars['String']['input'];
  merchantId: Scalars['String']['input'];
}>;


export type UpdateGoogleAdsCredentialsMutation = { __typename?: 'Mutation', updateGoogleAdsCredentials: { __typename?: 'Integration', id: string, credentials: { __typename?: 'AttentiveCredentials' } | { __typename?: 'GA4Credentials' } | { __typename?: 'GoogleAdsCredentials', customerId: string, merchantId: string } | { __typename?: 'KlaviyoCredentials' } | { __typename?: 'MetaCredentials' } | { __typename?: 'PostscriptCredentials' } | { __typename?: 'RedoCredentials' } | { __typename?: 'SnapchatCredentials' } | { __typename?: 'TiktokCredentials' } } };

export type UpdateGa4CredentialsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  measurementId: Scalars['String']['input'];
}>;


export type UpdateGa4CredentialsMutation = { __typename?: 'Mutation', updateGa4Credentials: { __typename?: 'Integration', id: string, credentials: { __typename?: 'AttentiveCredentials' } | { __typename?: 'GA4Credentials', measurementId: string } | { __typename?: 'GoogleAdsCredentials' } | { __typename?: 'KlaviyoCredentials' } | { __typename?: 'MetaCredentials' } | { __typename?: 'PostscriptCredentials' } | { __typename?: 'RedoCredentials' } | { __typename?: 'SnapchatCredentials' } | { __typename?: 'TiktokCredentials' } } };

export type UpdateIntegrationEventsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  merchantId: Scalars['String']['input'];
  events: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateIntegrationEventsMutation = { __typename?: 'Mutation', updateIntegrationEvents: { __typename?: 'Integration', id: string } };

export type UpdateIntegrationEventsV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  events: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateIntegrationEventsV2Mutation = { __typename?: 'Mutation', updateIntegrationEventsV2: { __typename?: 'IntegrationV2Properties', id: string } };

export type UpdateIntegrationMetadataV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metadata: Scalars['JSON']['input'];
}>;


export type UpdateIntegrationMetadataV2Mutation = { __typename?: 'Mutation', updateIntegrationMetadataV2: { __typename?: 'IntegrationV2Properties', id: string, metadata?: { __typename: 'GA4MetadataModel', productIdentifier: string } | { __typename: 'GoogleAdsMetadataModel', contentType: string, productIdentifier: string, googleAdsCtids: { __typename?: 'GoogleAdsCtidsModel', ctids: any } } | { __typename: 'MetaMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'SnapchatMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'TikTokMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | null } };

export type UpdateIntegrationMetadataMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  metadata: MetadataInput;
}>;


export type UpdateIntegrationMetadataMutation = { __typename?: 'Mutation', updateIntegrationMetadata: { __typename?: 'Integration', id: string } };

export type UpdatePropertyFiltersV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: Array<PropertyFilterInputV2> | PropertyFilterInputV2;
}>;


export type UpdatePropertyFiltersV2Mutation = { __typename?: 'Mutation', updatePropertyFiltersV2: { __typename?: 'IntegrationV2Properties', id: string } };

export type UpdateIntegrationStatusV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: ConnectionStatusV2;
}>;


export type UpdateIntegrationStatusV2Mutation = { __typename?: 'Mutation', updateIntegrationStatusV2: { __typename?: 'IntegrationV2Properties', id: string, status: ConnectionStatusV2 } };

export type DeleteIntegrationV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIntegrationV2Mutation = { __typename?: 'Mutation', deleteIntegrationV2: string };

export type UpdateIntegrationConsentModeV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  consentMode: Scalars['Boolean']['input'];
}>;


export type UpdateIntegrationConsentModeV2Mutation = { __typename?: 'Mutation', updateIntegrationConsentModeV2: { __typename?: 'IntegrationV2Properties', id: string, consentMode?: boolean | null } };

export type UpdateIntegrationConsentModeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  consentMode: Scalars['Boolean']['input'];
}>;


export type UpdateIntegrationConsentModeMutation = { __typename?: 'Mutation', updateIntegrationConsentMode: { __typename?: 'Integration', id: string } };

export type UpdateIntegrationSmartQualifyV2MutationVariables = Exact<{
  id: Scalars['ID']['input'];
  smartQualify: Scalars['Boolean']['input'];
}>;


export type UpdateIntegrationSmartQualifyV2Mutation = { __typename?: 'Mutation', updateSmartQualifyV2: { __typename?: 'IntegrationV2Properties', id: string, smartQualify?: boolean | null } };

export type GoogleAdsEnsureConversionActionsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  customerId: Scalars['String']['input'];
  events: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GoogleAdsEnsureConversionActionsMutation = { __typename?: 'Mutation', googleAdsEnsureConversionActions: Array<{ __typename?: 'CtidEntry', event: string, ctid: { __typename?: 'Ctid', id: string, userCreated: boolean, selected: boolean } }> };

export type UpdateSegmentMutationVariables = Exact<{
  segment_id: Scalars['String']['input'];
  input: CreateSegmentInput;
}>;


export type UpdateSegmentMutation = { __typename?: 'Mutation', updateSegment: string };

export type GetCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns: Array<{ __typename?: 'Campaign', campaignId: string, merchantId: string, name: string, type: CampaignType, status: CampaignStatus, createdBy: string, createdAt: string, updatedAt: string, scheduled?: any | null, generatedAt?: string | null, metadata?: any | null, metrics: { __typename?: 'CampaignMetrics', opened: number, sent: number, clicked: number, ordered: number, earned: number }, segments: { __typename?: 'Segments', include: Array<string>, exclude: Array<string> }, variants: Array<{ __typename?: 'CampaignVariant', variantId: string, campaignId: string, channel: Channel, variantName: string, splitWeight: number, content?: any | null, metadata?: any | null, createdAt: string, updatedAt: string }> }> };

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', campaign: { __typename?: 'Campaign', campaignId: string, merchantId: string, name: string, type: CampaignType, status: CampaignStatus, createdBy: string, createdAt: string, updatedAt: string, scheduled?: any | null, generatedAt?: string | null, metadata?: any | null, metrics: { __typename?: 'CampaignMetrics', opened: number, sent: number, clicked: number, ordered: number, earned: number }, segments: { __typename?: 'Segments', include: Array<string>, exclude: Array<string> }, variants: Array<{ __typename?: 'CampaignVariant', variantId: string, campaignId: string, channel: Channel, variantName: string, splitWeight: number, content?: any | null, metadata?: any | null, createdAt: string, updatedAt: string }> } };

export type IntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsQuery = { __typename?: 'Query', integrations: Array<{ __typename?: 'Integration', id: string, name: string, type: IntegrationType, status: ConnectionStatus, smartQualify?: boolean | null, consentMode?: boolean | null, metadata: { __typename?: 'Metadata', contentType?: ContentType | null, productIdentifier?: ProductIdentifier | null, googleAdsCtids?: { __typename?: 'GoogleAdsCtids', ctids: Array<{ __typename?: 'CtidEntry', event: string, ctid: { __typename?: 'Ctid', id: string, userCreated: boolean, selected: boolean } }> } | null }, filters: Array<{ __typename?: 'Filter', id: string, eventName: string, isEnabled: boolean, propertyFilters: Array<{ __typename?: 'PropertyFilter', prop: string, operator: Operator, value: Array<string> }> }>, credentials: { __typename?: 'AttentiveCredentials' } | { __typename?: 'GA4Credentials', measurementId: string } | { __typename?: 'GoogleAdsCredentials', customerId: string, merchantId: string } | { __typename?: 'KlaviyoCredentials', apiKey: string } | { __typename?: 'MetaCredentials', accessToken: string, id: string } | { __typename?: 'PostscriptCredentials', shopToken: string } | { __typename?: 'RedoCredentials' } | { __typename?: 'SnapchatCredentials', accessToken: string, snapchatId: string } | { __typename?: 'TiktokCredentials', accessToken: string, tiktokId: string } }> };

export type IntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IntegrationQuery = { __typename?: 'Query', integration: { __typename?: 'Integration', id: string, name: string, type: IntegrationType, status: ConnectionStatus, consentMode?: boolean | null, smartQualify?: boolean | null, metadata: { __typename?: 'Metadata', contentType?: ContentType | null, productIdentifier?: ProductIdentifier | null, googleAdsCtids?: { __typename?: 'GoogleAdsCtids', ctids: Array<{ __typename?: 'CtidEntry', event: string, ctid: { __typename?: 'Ctid', id: string, userCreated: boolean, selected: boolean } }> } | null }, filters: Array<{ __typename?: 'Filter', id: string, eventName: string, isEnabled: boolean, propertyFilters: Array<{ __typename?: 'PropertyFilter', prop: string, operator: Operator, value: Array<string> }> }>, credentials: { __typename?: 'AttentiveCredentials' } | { __typename?: 'GA4Credentials', measurementId: string } | { __typename?: 'GoogleAdsCredentials', customerId: string, merchantId: string } | { __typename?: 'KlaviyoCredentials', apiKey: string } | { __typename?: 'MetaCredentials', accessToken: string, id: string } | { __typename?: 'PostscriptCredentials', shopToken: string } | { __typename?: 'RedoCredentials' } | { __typename?: 'SnapchatCredentials', accessToken: string, snapchatId: string } | { __typename?: 'TiktokCredentials', accessToken: string, tiktokId: string } } };

export type GoogleAdsConversionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  customerId: Scalars['String']['input'];
}>;


export type GoogleAdsConversionQuery = { __typename?: 'Query', googleAdsGetConversionActions: Array<{ __typename?: 'GoogleAdsConversionAction', id: string, name: string, status: string, type: string }> };

export type IntegrationsV2QueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationsV2Query = { __typename?: 'Query', integrationsV2: Array<{ __typename?: 'IntegrationV2Properties', id: string, name: string, type: IntegrationTypeV2, status: ConnectionStatusV2, consentMode?: boolean | null, smartQualify?: boolean | null, metadata?: { __typename: 'GA4MetadataModel', productIdentifier: string } | { __typename: 'GoogleAdsMetadataModel', contentType: string, productIdentifier: string, googleAdsCtids: { __typename?: 'GoogleAdsCtidsModel', ctids: any } } | { __typename: 'MetaMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'SnapchatMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'TikTokMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | null, credentials?: { __typename: 'AttentiveCredentialsModel', attentiveApiKey: string } | { __typename: 'GA4CredentialsModel', measurementId: string } | { __typename: 'GoogleAdsCredentialsModel', customerId: string, merchantId: string } | { __typename: 'KlaviyoCredentialsModel', apiKey: string } | { __typename: 'MetaCredentialsModel', accessToken: string, id: string } | { __typename: 'PostscriptCredentialsModel', shopToken: string } | { __typename: 'RedoCredentialsModel', redoAccessToken: string, redoStoreId: string, redoWidgetId?: string | null } | { __typename: 'SendlaneCredentialsModel' } | { __typename: 'SnapchatCredentialsModel', accessToken: string, snapchatId: string } | { __typename: 'TikTokCredentialsModel', accessToken: string, tiktokId: string } | { __typename: 'WebhookCredentialsModel', webhookUrl: string } | null, findFiltersV2: Array<{ __typename?: 'FilterV2', id: string, eventName: string, isEnabled: boolean, propertyFilters: Array<{ __typename?: 'PropertyFilterV2', prop: string, operator: OperatorV2, value: Array<string> }> }> }> };

export type IntegrationV2QueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IntegrationV2Query = { __typename?: 'Query', integrationV2: { __typename?: 'IntegrationV2Properties', id: string, name: string, type: IntegrationTypeV2, status: ConnectionStatusV2, consentMode?: boolean | null, smartQualify?: boolean | null, metadata?: { __typename: 'GA4MetadataModel', productIdentifier: string } | { __typename: 'GoogleAdsMetadataModel', contentType: string, productIdentifier: string, googleAdsCtids: { __typename?: 'GoogleAdsCtidsModel', ctids: any } } | { __typename: 'MetaMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'SnapchatMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | { __typename: 'TikTokMetadataModel', contentType: string, productIdentifier: string, tagDelivery?: string | null } | null, credentials?: { __typename: 'AttentiveCredentialsModel', attentiveApiKey: string } | { __typename: 'GA4CredentialsModel', measurementId: string } | { __typename: 'GoogleAdsCredentialsModel', customerId: string, merchantId: string } | { __typename: 'KlaviyoCredentialsModel', apiKey: string } | { __typename: 'MetaCredentialsModel', accessToken: string, id: string } | { __typename: 'PostscriptCredentialsModel', shopToken: string } | { __typename: 'RedoCredentialsModel', redoAccessToken: string, redoStoreId: string, redoWidgetId?: string | null } | { __typename: 'SendlaneCredentialsModel', apiKey: string, integrationToken: string } | { __typename: 'SnapchatCredentialsModel', accessToken: string, snapchatId: string } | { __typename: 'TikTokCredentialsModel', accessToken: string, tiktokId: string } | { __typename: 'WebhookCredentialsModel', webhookUrl: string } | null, findFiltersV2: Array<{ __typename?: 'FilterV2', id: string, eventName: string, isEnabled: boolean, propertyFilters: Array<{ __typename?: 'PropertyFilterV2', prop: string, operator: OperatorV2, value: Array<string> }> }> } };

export type GetConversionMonitoringMetricsQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetConversionMonitoringMetricsQuery = { __typename?: 'Query', getConversionMonitoringMetrics: { __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } };

export type GetVisitorsRecognizedQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetVisitorsRecognizedQuery = { __typename?: 'Query', getVisitorsRecognized: { __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } };

export type GetTotalEventsTrackedQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetTotalEventsTrackedQuery = { __typename?: 'Query', getTotalEventsTracked: Array<{ __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null }> };

export type GetAnonVisitorsCapturedQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAnonVisitorsCapturedQuery = { __typename?: 'Query', getAnonVisitorsCaptured: { __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } };

export type GetServerEventLogsQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetServerEventLogsQuery = { __typename?: 'Query', getServerEventLogs: Array<{ __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null }> };

export type GetProfilesListQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetProfilesListQuery = { __typename?: 'Query', getProfilesList: { __typename?: 'GetProfilesListResponse', anonVisitorCount?: number | null, profiles: Array<{ __typename?: 'Profile', email: string, firstName: string, lastName: string, lastSeen: string, phone: string, source: ProfileSource }> } };

export type GetProfilesMetricsQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetProfilesMetricsQuery = { __typename?: 'Query', getProfileMetrics: { __typename?: 'MetricsResponse', totalProfiles: number, anonVisitorCount: number } };

export type GetMetricsComparisonQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  metricType: MetricComparisonType;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMetricsComparisonQuery = { __typename?: 'Query', getMetricsComparison: { __typename?: 'MetricsComparison', percentageChange: number, absoluteChange: number, currentPeriod: { __typename?: 'Metric', aggregate: number, data: Array<number>, labels: Array<string>, chartUnit: ChartUnit, aggregateMethod: AggregateMethod, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null }, previousPeriod: { __typename?: 'Metric', aggregate: number, data: Array<number>, labels: Array<string>, chartUnit: ChartUnit, aggregateMethod: AggregateMethod, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } } };

export type GetLifecycleRevenueQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLifecycleRevenueQuery = { __typename?: 'Query', getLifecycleRevenue: { __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } };

export type GetFlowsRevenueQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  fromDate: Scalars['String']['input'];
  toDate: Scalars['String']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetFlowsRevenueQuery = { __typename?: 'Query', getFlowsRevenue: { __typename?: 'Metric', chartUnit: ChartUnit, aggregateMethod: AggregateMethod, labels: Array<string>, data: Array<number>, aggregate: number, dateRange?: { __typename?: 'DateRange', fromDate: string, toDate: string } | null } };

export type GetLifetimeRevenueQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLifetimeRevenueQuery = { __typename?: 'Query', getLifetimeRevenue: number };

export type GetLifetimeRoiQueryVariables = Exact<{
  merchantId: Scalars['ID']['input'];
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetLifetimeRoiQuery = { __typename?: 'Query', getLifetimeROI?: number | null };

export type GetEmqScoresByDateRangeQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetEmqScoresByDateRangeQuery = { __typename?: 'Query', getEMQScoresByDateRange: Array<{ __typename?: 'DailyEMQScore', date: string, META_ADD_PAYMENT_INFO_EMQ_SCORE?: number | null, META_VIEW_CONTENT_EMQ_SCORE?: number | null, META_PAGE_VIEW_EMQ_SCORE?: number | null, META_INITIATE_CHECKOUT_EMQ_SCORE?: number | null, META_PURCHASE_EMQ_SCORE?: number | null, META_LEAD_EMQ_SCORE?: number | null, META_ADD_TO_CART_EMQ_SCORE?: number | null }> };

export type GetEmqScoreAverageAndTrendQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetEmqScoreAverageAndTrendQuery = { __typename?: 'Query', getEMQScoreAverageAndTrend: { __typename?: 'EMQScoreAverageAndTrend', priorScore?: number | null, endScore?: number | null, avgScore?: number | null } };

export type GetEmqScoreDefaultAndAverageQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type GetEmqScoreDefaultAndAverageQuery = { __typename?: 'Query', getEMQScoreDefaultAndAverageForTimePeriod: Array<{ __typename?: 'DefaultAndAverageRow', eventName: string, priorScore?: number | null, currentAvg?: number | null }> };

export type GetAllSegmentsMetadataQueryVariables = Exact<{
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllSegmentsMetadataQuery = { __typename?: 'Query', getAllSegmentMetadataForMerchant: Array<{ __typename?: 'FindSegmentQueryResult', id: string, name: string, description: string, lastCalculatedSize?: number | null, createdAt: string, active: boolean, lastCalculatedAt?: string | null }> };

export type GetSegmentForBuilderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetSegmentForBuilderQuery = { __typename?: 'Query', getSegmentMetadataBySegmentId: { __typename?: 'FindSegmentQueryResult', id: string, name: string, description: string, active: boolean, createdAt: string, createdBy: string, lastUpdatedAt?: string | null, lastUpdatedBy: string, lastCalculatedAt?: string | null, lastCalculatedSize?: number | null, parentSegmentIds: Array<string>, segment: { __typename?: 'SegmentDefinition', rootOperator: SegmentOperator, groups: Array<{ __typename?: 'ConditionGroup', id?: string | null, operator: SegmentOperator, conditions: Array<{ __typename?: 'EventCondition', eventName: CanonicalEventName, operator: CountOperator, numTimes: number, id?: string | null, conditionType: ConditionTypeEnum, timeBoundary: { __typename?: 'TimeBoundary', type: TimeBoundaryType, conversionWindow?: { __typename?: 'ConversionWindow', num_unit: number, conversion_unit: ConversionUnit } | null, timeRange?: { __typename?: 'SegmentTimeRange', fromTime: string, toTime: string } | null } } | { __typename?: 'FunnelCondition', maxSecondsBetweenSteps: number, id?: string | null, conditionType: ConditionTypeEnum, timeBoundary: { __typename?: 'TimeBoundary', type: TimeBoundaryType, conversionWindow?: { __typename?: 'ConversionWindow', num_unit: number, conversion_unit: ConversionUnit } | null, timeRange?: { __typename?: 'SegmentTimeRange', fromTime: string, toTime: string } | null }, steps: Array<{ __typename?: 'FunnelStep', eventName: CanonicalEventName, countOperator: CountOperator, numTimes: number }> } | { __typename?: 'SegmentMembershipCondition', segmentId: string, isMember: boolean, id?: string | null, conditionType: ConditionTypeEnum } | { __typename?: 'UserPropertyCondition', propertyName: SupportedUserProperty, comparisonOperator: ComparisonOperator, stringValue?: string | null, intValue?: number | null, floatValue?: number | null, boolValue?: boolean | null, stringArrayValue?: Array<string> | null, id?: string | null, conditionType: ConditionTypeEnum }> }> } } };

export type EstimateSegmentCountQueryVariables = Exact<{
  input: GetSegmentUsersInput;
}>;


export type EstimateSegmentCountQuery = { __typename?: 'Query', estimateSegmentCount: number };

export type EstimateSegmentDefinitionQueryVariables = Exact<{
  input: EstimateSegmentDefinitionInput;
}>;


export type EstimateSegmentDefinitionQuery = { __typename?: 'Query', estimateSegmentDefinition: number };

export type IsEmqEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IsEmqEnabledQuery = { __typename?: 'Query', merchant: { __typename?: 'MerchantModel', emqScoreEnabled: boolean } };

export type GetMerchantIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantIdQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', id?: string | null, domain?: string | null } };

export type VerifyTxtRecordMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyTxtRecordMutation = { __typename?: 'Mutation', verifyTxtRecord: Array<{ __typename?: 'DnsRecord', id: string, type: DnsRecordType, name: string, value: string, verified: boolean }> };

export type VerifyCnameRecordMutationVariables = Exact<{ [key: string]: never; }>;


export type VerifyCnameRecordMutation = { __typename?: 'Mutation', verifyCnameRecord: { __typename?: 'DnsRecord', id: string, type: DnsRecordType, name: string, value: string, verified: boolean } };

export type CurrentMerchantForDnsRecordsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMerchantForDnsRecordsQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', id?: string | null, websiteUrl?: string | null, dnsVerificationRecords: Array<{ __typename?: 'DnsRecord', id: string, type: DnsRecordType, name: string, value: string, verified: boolean }> } };

export type CurrentMerchantForVerifyDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMerchantForVerifyDomainQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', isDomainVerified: boolean, id?: string | null, websiteUrl?: string | null } };

export type VerifyDomainMutationVariables = Exact<{
  websiteUrl: Scalars['String']['input'];
}>;


export type VerifyDomainMutation = { __typename?: 'Mutation', verifyDomain: { __typename?: 'Merchant', id?: string | null, isDomainVerified: boolean, websiteUrl?: string | null } };

export type GetActiveUniqueProfilesMetricsQueryVariables = Exact<{
  filters: MetricCaptureRateFilter;
}>;


export type GetActiveUniqueProfilesMetricsQuery = { __typename?: 'Query', getActiveUniqueProfileMetrics: { __typename?: 'ActiveUniqueProfileMetricsResponse', totalProfiles: number } };

export type GetEmailCaptureRateQueryVariables = Exact<{
  filters: MetricCaptureRateFilter;
}>;


export type GetEmailCaptureRateQuery = { __typename?: 'Query', getEmailCaptureRate: { __typename?: 'EmailCaptureRateResponse', emailCaptureRate: number } };

export type GetProfileListV2QueryVariables = Exact<{
  filters: ListProfilesFilters;
  pagination: ListProfilesPagination;
}>;


export type GetProfileListV2Query = { __typename?: 'Query', listProfiles: Array<{ __typename?: 'ProfileV2Response', email?: string | null, firstName?: string | null, lastName?: string | null, lastSeen: string, phone?: string | null, emailOptIn?: boolean | null, firstSeen: string }> };

export type CreateSegmentMutationVariables = Exact<{
  input: CreateSegmentInput;
}>;


export type CreateSegmentMutation = { __typename?: 'Mutation', createSegment: string };

export type SyncShopifyDataMutationVariables = Exact<{
  merchantId: Scalars['String']['input'];
  shopUrl: Scalars['String']['input'];
  accessToken: Scalars['String']['input'];
}>;


export type SyncShopifyDataMutation = { __typename?: 'Mutation', syncShopifyData: string };

export type SyncKlaviyoDataMutationVariables = Exact<{
  merchantId: Scalars['String']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type SyncKlaviyoDataMutation = { __typename?: 'Mutation', syncKlaviyoData: string };

export type CurrentMerchantForCompanyInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMerchantForCompanyInformationQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', id?: string | null, address1?: string | null, address2?: string | null, businessName?: string | null, city?: string | null, country?: string | null, einNumber?: string | null, websiteUrl?: string | null, websiteName?: string | null, province?: string | null, zip?: string | null, timezone?: string | null, merchantCategory?: string | null } };

export type UpdateMerchantForCompanyInformationMutationVariables = Exact<{
  input: UpdateCurrentMerchant;
}>;


export type UpdateMerchantForCompanyInformationMutation = { __typename?: 'Mutation', updateCurrentMerchant: { __typename?: 'Merchant', id?: string | null, address1?: string | null, address2?: string | null, businessName?: string | null, city?: string | null, country?: string | null, einNumber?: string | null, websiteUrl?: string | null, websiteName?: string | null, province?: string | null, zip?: string | null, timezone?: string | null, merchantCategory?: string | null } };

export type CurrentMerchantForConsentQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMerchantForConsentQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', id?: string | null, hasConsentEnabled?: boolean | null } };

export type SetConsentMutationVariables = Exact<{
  consent: Scalars['Boolean']['input'];
}>;


export type SetConsentMutation = { __typename?: 'Mutation', setConsent: { __typename?: 'Merchant', id?: string | null, hasConsentEnabled?: boolean | null } };

export type StoreDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type StoreDetailsQuery = { __typename?: 'Query', currentMerchant: { __typename?: 'Merchant', id?: string | null } };

export type CreateIntegrationV2MutationVariables = Exact<{
  input: CreateIntegrationInputV2;
}>;


export type CreateIntegrationV2Mutation = { __typename?: 'Mutation', createIntegrationV2: { __typename?: 'IntegrationV2Properties', id: string, name: string, type: IntegrationTypeV2, status: ConnectionStatusV2 } };


export const GetMerchantTimezoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMerchantTimezone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMerchantTimezone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}}]}]}}]} as unknown as DocumentNode<GetMerchantTimezoneQuery, GetMerchantTimezoneQueryVariables>;
export const CreateCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"splitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const SetStatusAsScheduledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetStatusAsScheduled"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setStatusAsScheduled"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"splitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<SetStatusAsScheduledMutation, SetStatusAsScheduledMutationVariables>;
export const UpdateCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCampaignInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"updateCampaignId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"splitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const DeleteCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteCampaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"campaignId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<DeleteCampaignMutation, DeleteCampaignMutationVariables>;
export const SendCampaignPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendCampaignPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendCampaignPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendCampaignPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SendCampaignPreviewMutation, SendCampaignPreviewMutationVariables>;
export const UpdateCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationCredentialsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"credentials"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentials"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4CredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KlaviyoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostscriptCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"snapchatId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendlaneCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"integrationToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AttentiveCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attentiveApiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redoAccessToken"}},{"kind":"Field","name":{"kind":"Name","value":"redoStoreId"}},{"kind":"Field","name":{"kind":"Name","value":"redoWidgetId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebhookCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhookUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeSigningSecret"}}]}}]}}]} as unknown as DocumentNode<UpdateCredentialsMutation, UpdateCredentialsMutationVariables>;
export const UpdateGoogleAdsCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGoogleAdsCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGoogleAdsCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGoogleAdsCredentialsMutation, UpdateGoogleAdsCredentialsMutationVariables>;
export const UpdateGa4CredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateGa4Credentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"measurementId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateGa4Credentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"measurementId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"measurementId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4Credentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateGa4CredentialsMutation, UpdateGa4CredentialsMutationVariables>;
export const UpdateIntegrationEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"events"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationEventsMutation, UpdateIntegrationEventsMutationVariables>;
export const UpdateIntegrationEventsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationEventsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationEventsV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"events"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationEventsV2Mutation, UpdateIntegrationEventsV2MutationVariables>;
export const UpdateIntegrationMetadataV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationMetadataV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationMetadataV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4MetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"googleAdsCtids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctids"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationMetadataV2Mutation, UpdateIntegrationMetadataV2MutationVariables>;
export const UpdateIntegrationMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetadataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationMetadataMutation, UpdateIntegrationMetadataMutationVariables>;
export const UpdatePropertyFiltersV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyFiltersV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyFilterInputV2"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePropertyFiltersV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyFiltersV2Mutation, UpdatePropertyFiltersV2MutationVariables>;
export const UpdateIntegrationStatusV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationStatusV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConnectionStatusV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationStatusV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationStatusV2Mutation, UpdateIntegrationStatusV2MutationVariables>;
export const DeleteIntegrationV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteIntegrationV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteIntegrationV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteIntegrationV2Mutation, DeleteIntegrationV2MutationVariables>;
export const UpdateIntegrationConsentModeV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationConsentModeV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationConsentModeV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"consentMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"consentMode"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationConsentModeV2Mutation, UpdateIntegrationConsentModeV2MutationVariables>;
export const UpdateIntegrationConsentModeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationConsentMode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consentMode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIntegrationConsentMode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"consentMode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consentMode"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationConsentModeMutation, UpdateIntegrationConsentModeMutationVariables>;
export const UpdateIntegrationSmartQualifyV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateIntegrationSmartQualifyV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"smartQualify"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSmartQualifyV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"smartQualify"},"value":{"kind":"Variable","name":{"kind":"Name","value":"smartQualify"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"smartQualify"}}]}}]}}]} as unknown as DocumentNode<UpdateIntegrationSmartQualifyV2Mutation, UpdateIntegrationSmartQualifyV2MutationVariables>;
export const GoogleAdsEnsureConversionActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GoogleAdsEnsureConversionActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleAdsEnsureConversionActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"events"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"ctid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userCreated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}}]}}]}}]}}]} as unknown as DocumentNode<GoogleAdsEnsureConversionActionsMutation, GoogleAdsEnsureConversionActionsMutationVariables>;
export const UpdateSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"segment_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSegmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"segment_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"segment_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateSegmentMutation, UpdateSegmentMutationVariables>;
export const GetCampaignsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opened"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"clicked"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"splitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignsQuery, GetCampaignsQueryVariables>;
export const GetCampaignDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCampaign"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaign"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"scheduled"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"metrics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"opened"}},{"kind":"Field","name":{"kind":"Name","value":"sent"}},{"kind":"Field","name":{"kind":"Name","value":"clicked"}},{"kind":"Field","name":{"kind":"Name","value":"ordered"}},{"kind":"Field","name":{"kind":"Name","value":"earned"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"include"}},{"kind":"Field","name":{"kind":"Name","value":"exclude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"variants"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"variantId"}},{"kind":"Field","name":{"kind":"Name","value":"campaignId"}},{"kind":"Field","name":{"kind":"Name","value":"channel"}},{"kind":"Field","name":{"kind":"Name","value":"variantName"}},{"kind":"Field","name":{"kind":"Name","value":"splitWeight"}},{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetCampaignQuery, GetCampaignQueryVariables>;
export const IntegrationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"smartQualify"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"googleAdsCtids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"ctid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userCreated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"propertyFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prop"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4Credentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KlaviyoCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostscriptCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"snapchatId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TiktokCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentMode"}}]}}]}}]} as unknown as DocumentNode<IntegrationsQuery, IntegrationsQueryVariables>;
export const IntegrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Integration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"consentMode"}},{"kind":"Field","name":{"kind":"Name","value":"smartQualify"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"googleAdsCtids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"ctid"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userCreated"}},{"kind":"Field","name":{"kind":"Name","value":"selected"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"filters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"propertyFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prop"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4Credentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KlaviyoCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostscriptCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"snapchatId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TiktokCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntegrationQuery, IntegrationQueryVariables>;
export const GoogleAdsConversionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GoogleAdsConversion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"googleAdsGetConversionActions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"customerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<GoogleAdsConversionQuery, GoogleAdsConversionQueryVariables>;
export const IntegrationsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntegrationsV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationsV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4MetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"googleAdsCtids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctids"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4CredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KlaviyoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostscriptCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"snapchatId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AttentiveCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attentiveApiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redoAccessToken"}},{"kind":"Field","name":{"kind":"Name","value":"redoStoreId"}},{"kind":"Field","name":{"kind":"Name","value":"redoWidgetId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebhookCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhookUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentMode"}},{"kind":"Field","name":{"kind":"Name","value":"smartQualify"}},{"kind":"Field","name":{"kind":"Name","value":"findFiltersV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"propertyFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prop"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntegrationsV2Query, IntegrationsV2QueryVariables>;
export const IntegrationV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IntegrationV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"integrationV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4MetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"googleAdsCtids"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ctids"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatMetadataModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"productIdentifier"}},{"kind":"Field","name":{"kind":"Name","value":"tagDelivery"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MetaCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GA4CredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"measurementId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"KlaviyoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PostscriptCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shopToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SnapchatCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"snapchatId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TikTokCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"tiktokId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleAdsCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerId"}},{"kind":"Field","name":{"kind":"Name","value":"merchantId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendlaneCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apiKey"}},{"kind":"Field","name":{"kind":"Name","value":"integrationToken"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AttentiveCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attentiveApiKey"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedoCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redoAccessToken"}},{"kind":"Field","name":{"kind":"Name","value":"redoStoreId"}},{"kind":"Field","name":{"kind":"Name","value":"redoWidgetId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WebhookCredentialsModel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webhookUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"consentMode"}},{"kind":"Field","name":{"kind":"Name","value":"smartQualify"}},{"kind":"Field","name":{"kind":"Name","value":"findFiltersV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"isEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"propertyFilters"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prop"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]} as unknown as DocumentNode<IntegrationV2Query, IntegrationV2QueryVariables>;
export const GetConversionMonitoringMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConversionMonitoringMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConversionMonitoringMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetConversionMonitoringMetricsQuery, GetConversionMonitoringMetricsQueryVariables>;
export const GetVisitorsRecognizedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVisitorsRecognized"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getVisitorsRecognized"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetVisitorsRecognizedQuery, GetVisitorsRecognizedQueryVariables>;
export const GetTotalEventsTrackedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTotalEventsTracked"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTotalEventsTracked"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetTotalEventsTrackedQuery, GetTotalEventsTrackedQueryVariables>;
export const GetAnonVisitorsCapturedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAnonVisitorsCaptured"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAnonVisitorsCaptured"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetAnonVisitorsCapturedQuery, GetAnonVisitorsCapturedQueryVariables>;
export const GetServerEventLogsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServerEventLogs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getServerEventLogs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetServerEventLogsQuery, GetServerEventLogsQueryVariables>;
export const GetProfilesListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfilesList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProfilesList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"source"}}]}},{"kind":"Field","name":{"kind":"Name","value":"anonVisitorCount"}}]}}]}}]} as unknown as DocumentNode<GetProfilesListQuery, GetProfilesListQueryVariables>;
export const GetProfilesMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProfilesMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getProfileMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalProfiles"}},{"kind":"Field","name":{"kind":"Name","value":"anonVisitorCount"}}]}}]}}]} as unknown as DocumentNode<GetProfilesMetricsQuery, GetProfilesMetricsQueryVariables>;
export const GetMetricsComparisonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMetricsComparison"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metricType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricComparisonType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getMetricsComparison"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metricType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metricType"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"previousPeriod"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"percentageChange"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteChange"}}]}}]}}]} as unknown as DocumentNode<GetMetricsComparisonQuery, GetMetricsComparisonQueryVariables>;
export const GetLifecycleRevenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLifecycleRevenue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLifecycleRevenue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetLifecycleRevenueQuery, GetLifecycleRevenueQueryVariables>;
export const GetFlowsRevenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlowsRevenue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFlowsRevenue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fromDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"toDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromDate"}},{"kind":"Field","name":{"kind":"Name","value":"toDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"chartUnit"}},{"kind":"Field","name":{"kind":"Name","value":"aggregateMethod"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"aggregate"}}]}}]}}]} as unknown as DocumentNode<GetFlowsRevenueQuery, GetFlowsRevenueQueryVariables>;
export const GetLifetimeRevenueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLifetimeRevenue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLifetimeRevenue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}]}}]} as unknown as DocumentNode<GetLifetimeRevenueQuery, GetLifetimeRevenueQueryVariables>;
export const GetLifetimeRoiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLifetimeROI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLifetimeROI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"refresh"},"value":{"kind":"Variable","name":{"kind":"Name","value":"refresh"}}}]}]}}]} as unknown as DocumentNode<GetLifetimeRoiQuery, GetLifetimeRoiQueryVariables>;
export const GetEmqScoresByDateRangeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEMQScoresByDateRange"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEMQScoresByDateRange"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"META_ADD_PAYMENT_INFO_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_VIEW_CONTENT_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_PAGE_VIEW_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_INITIATE_CHECKOUT_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_PURCHASE_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_LEAD_EMQ_SCORE"}},{"kind":"Field","name":{"kind":"Name","value":"META_ADD_TO_CART_EMQ_SCORE"}}]}}]}}]} as unknown as DocumentNode<GetEmqScoresByDateRangeQuery, GetEmqScoresByDateRangeQueryVariables>;
export const GetEmqScoreAverageAndTrendDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEMQScoreAverageAndTrend"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEMQScoreAverageAndTrend"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priorScore"}},{"kind":"Field","name":{"kind":"Name","value":"endScore"}},{"kind":"Field","name":{"kind":"Name","value":"avgScore"}}]}}]}}]} as unknown as DocumentNode<GetEmqScoreAverageAndTrendQuery, GetEmqScoreAverageAndTrendQueryVariables>;
export const GetEmqScoreDefaultAndAverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEMQScoreDefaultAndAverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEMQScoreDefaultAndAverageForTimePeriod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"priorScore"}},{"kind":"Field","name":{"kind":"Name","value":"currentAvg"}}]}}]}}]} as unknown as DocumentNode<GetEmqScoreDefaultAndAverageQuery, GetEmqScoreDefaultAndAverageQueryVariables>;
export const GetAllSegmentsMetadataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllSegmentsMetadata"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAllSegmentMetadataForMerchant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"includeDeleted"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includeDeleted"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"lastCalculatedSize"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"lastCalculatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAllSegmentsMetadataQuery, GetAllSegmentsMetadataQueryVariables>;
export const GetSegmentForBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSegmentForBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getSegmentMetadataBySegmentId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedBy"}},{"kind":"Field","name":{"kind":"Name","value":"lastCalculatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastCalculatedSize"}},{"kind":"Field","name":{"kind":"Name","value":"parentSegmentIds"}},{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rootOperator"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditionType"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EventCondition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"numTimes"}},{"kind":"Field","name":{"kind":"Name","value":"timeBoundary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"conversionWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"num_unit"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromTime"}},{"kind":"Field","name":{"kind":"Name","value":"toTime"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserPropertyCondition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyName"}},{"kind":"Field","name":{"kind":"Name","value":"comparisonOperator"}},{"kind":"Field","name":{"kind":"Name","value":"stringValue"}},{"kind":"Field","name":{"kind":"Name","value":"intValue"}},{"kind":"Field","name":{"kind":"Name","value":"floatValue"}},{"kind":"Field","name":{"kind":"Name","value":"boolValue"}},{"kind":"Field","name":{"kind":"Name","value":"stringArrayValue"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FunnelCondition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxSecondsBetweenSteps"}},{"kind":"Field","name":{"kind":"Name","value":"timeBoundary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"conversionWindow"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"num_unit"}},{"kind":"Field","name":{"kind":"Name","value":"conversion_unit"}}]}},{"kind":"Field","name":{"kind":"Name","value":"timeRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fromTime"}},{"kind":"Field","name":{"kind":"Name","value":"toTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventName"}},{"kind":"Field","name":{"kind":"Name","value":"countOperator"}},{"kind":"Field","name":{"kind":"Name","value":"numTimes"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SegmentMembershipCondition"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segmentId"}},{"kind":"Field","name":{"kind":"Name","value":"isMember"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSegmentForBuilderQuery, GetSegmentForBuilderQueryVariables>;
export const EstimateSegmentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateSegmentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetSegmentUsersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateSegmentCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<EstimateSegmentCountQuery, EstimateSegmentCountQueryVariables>;
export const EstimateSegmentDefinitionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EstimateSegmentDefinition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EstimateSegmentDefinitionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"estimateSegmentDefinition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<EstimateSegmentDefinitionQuery, EstimateSegmentDefinitionQueryVariables>;
export const IsEmqEnabledDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"IsEmqEnabled"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"merchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emqScoreEnabled"}}]}}]}}]} as unknown as DocumentNode<IsEmqEnabledQuery, IsEmqEnabledQueryVariables>;
export const GetMerchantIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMerchantId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"domain"}}]}}]}}]} as unknown as DocumentNode<GetMerchantIdQuery, GetMerchantIdQueryVariables>;
export const VerifyTxtRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyTxtRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyTxtRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<VerifyTxtRecordMutation, VerifyTxtRecordMutationVariables>;
export const VerifyCnameRecordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyCnameRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyCnameRecord"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]} as unknown as DocumentNode<VerifyCnameRecordMutation, VerifyCnameRecordMutationVariables>;
export const CurrentMerchantForDnsRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentMerchantForDnsRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dnsVerificationRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentMerchantForDnsRecordsQuery, CurrentMerchantForDnsRecordsQueryVariables>;
export const CurrentMerchantForVerifyDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentMerchantForVerifyDomain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDomainVerified"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]} as unknown as DocumentNode<CurrentMerchantForVerifyDomainQuery, CurrentMerchantForVerifyDomainQueryVariables>;
export const VerifyDomainDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyDomain"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyDomain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"websiteUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"websiteUrl"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDomainVerified"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}}]}}]}}]} as unknown as DocumentNode<VerifyDomainMutation, VerifyDomainMutationVariables>;
export const GetActiveUniqueProfilesMetricsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveUniqueProfilesMetrics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricCaptureRateFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActiveUniqueProfileMetrics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalProfiles"}}]}}]}}]} as unknown as DocumentNode<GetActiveUniqueProfilesMetricsQuery, GetActiveUniqueProfilesMetricsQueryVariables>;
export const GetEmailCaptureRateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEmailCaptureRate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetricCaptureRateFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getEmailCaptureRate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailCaptureRate"}}]}}]}}]} as unknown as DocumentNode<GetEmailCaptureRateQuery, GetEmailCaptureRateQueryVariables>;
export const GetProfileListV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getProfileListV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filters"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProfilesFilters"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListProfilesPagination"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listProfiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filters"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pagination"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeen"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"emailOptIn"}},{"kind":"Field","name":{"kind":"Name","value":"firstSeen"}}]}}]}}]} as unknown as DocumentNode<GetProfileListV2Query, GetProfileListV2QueryVariables>;
export const CreateSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSegmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<CreateSegmentMutation, CreateSegmentMutationVariables>;
export const SyncShopifyDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncShopifyData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncShopifyData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"shop_url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"shopUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"access_token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessToken"}}}]}]}}]} as unknown as DocumentNode<SyncShopifyDataMutation, SyncShopifyDataMutationVariables>;
export const SyncKlaviyoDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncKlaviyoData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncKlaviyoData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"merchant_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"merchantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"api_key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"apiKey"}}}]}]}}]} as unknown as DocumentNode<SyncKlaviyoDataMutation, SyncKlaviyoDataMutationVariables>;
export const CurrentMerchantForCompanyInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentMerchantForCompanyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"einNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteName"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"merchantCategory"}}]}}]}}]} as unknown as DocumentNode<CurrentMerchantForCompanyInformationQuery, CurrentMerchantForCompanyInformationQueryVariables>;
export const UpdateMerchantForCompanyInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMerchantForCompanyInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateCurrentMerchant"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCurrentMerchant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address1"}},{"kind":"Field","name":{"kind":"Name","value":"address2"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"einNumber"}},{"kind":"Field","name":{"kind":"Name","value":"websiteUrl"}},{"kind":"Field","name":{"kind":"Name","value":"websiteName"}},{"kind":"Field","name":{"kind":"Name","value":"province"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"merchantCategory"}}]}}]}}]} as unknown as DocumentNode<UpdateMerchantForCompanyInformationMutation, UpdateMerchantForCompanyInformationMutationVariables>;
export const CurrentMerchantForConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentMerchantForConsent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsentEnabled"}}]}}]}}]} as unknown as DocumentNode<CurrentMerchantForConsentQuery, CurrentMerchantForConsentQueryVariables>;
export const SetConsentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetConsent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"consent"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setConsent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"consent"},"value":{"kind":"Variable","name":{"kind":"Name","value":"consent"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasConsentEnabled"}}]}}]}}]} as unknown as DocumentNode<SetConsentMutation, SetConsentMutationVariables>;
export const StoreDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoreDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentMerchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StoreDetailsQuery, StoreDetailsQueryVariables>;
export const CreateIntegrationV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIntegrationV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIntegrationInputV2"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIntegrationV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<CreateIntegrationV2Mutation, CreateIntegrationV2MutationVariables>;